/*!
 * Tradeshow Floor Plan — embeddable widget
 * Build: 2026-07-08-per-booth-dots
 * Usage:
 *   <div data-floor-plan></div>
 *   <script defer></script>
 *
 * Editor mode (drag/resize + export JSON):
 *   <div data-floor-plan data-editable></div>
 *   or append ?fp-edit=1 to the page URL
 *
 * Vendor fields: id, name, booth, category, description, website?, col, row, w?, h?
 */
(function () {
  "use strict";

  var SVG_NS = "http://www.w3.org/2000/svg";
  var COLS = 12;
  var ROWS = 9;
  1;
  var CELL = 180;
  // Tracks the active Sat/Sun day for share-link generation (set by mount()).
  var currentShareDay = "sat";
  var PAD = 90;
  var W = COLS * CELL + PAD * 2;
  var H = ROWS * CELL + PAD * 2;
  var ENTRANCE = { col: Math.ceil(COLS / 2), row: ROWS + 0.5 };

  // Every door walkers may emerge from: the main entrance plus any perimeter
  // doors declared via data-doors. Rebuilt on each render.
  var DOOR_POINTS = [];


  // Module-level map of blocked cells from walls: { "col,row": true }.
  // computePath treats these like occupied booth cells so walkers must
  // route around them (only openings — cells left out of the map — pass).
  var WALL_CELLS = {};

  var DEFAULT_VENDORS = [
    {
      id: "V1",
      name: "Northwind Robotics",
      booth: "4",
      category: "Automation",
      description: "Live demos all weekend.",
      col: 1,
      row: 6,
      w: 1,
    },
    {
      id: "V2",
      name: "Lumen Optics",
      booth: "1",
      category: "Hardware",
      description: "New products on display.",
      col: 1,
      row: 5,
      w: 1,
    },
    {
      id: "T52",
      booth: "20",
      name: "New Booth 52",
      category: "Uncategorized",
      description: "Add a short description for this vendor.",
      days: ["sat"],
      col: 10,
      row: 5,
    },
  ];

  // Default spotlights: shown when the host page does not pass data-spotlights.
  // Helps visualize the feature out of the box (and on mobile where operators
  // often don't get to configure the widget).
  var DEFAULT_SPOTLIGHTS = [
    {
      boothId: "V1",
      eyebrow: "Event exclusive",
      title: "Live robot demos",
      text: "All weekend — limited seating.",
      cta: "Navigate here",
    },
  ];

  var STYLE_ID = "lov-floor-plan-style";
  var CSS = [
    ".lov-fp{font-family:ui-sans-serif,system-ui,-apple-system,Segoe UI,Roboto,sans-serif;color:#0f172a;display:grid;gap:16px;grid-template-columns:1fr;width:100%}",
    ".lov-fp-left{display:flex;flex-direction:column;gap:12px;min-width:0}",
    "@media(min-width:900px){.lov-fp{grid-template-columns:minmax(0,1fr) 340px;align-items:start}.lov-fp-panel{position:sticky;top:16px}}",
    ".lov-fp *{box-sizing:border-box}",
    ".lov-fp-map{background:#fff;border:1px solid #e5e7eb;border-radius:12px;padding:12px;overflow:auto;position:relative;-webkit-overflow-scrolling:touch;touch-action:pan-x pan-y;overscroll-behavior:auto;max-width:100%;box-sizing:border-box}",
    ".lov-fp-map svg{display:block;width:100%;height:auto;min-width:900px;touch-action:pan-x pan-y}",
    "@media(min-width:900px){.lov-fp-map svg{width:auto;max-width:none;min-width:100%}}",
    ".lov-fp-zoom{display:flex;flex-direction:row;gap:4px;justify-content:center;align-items:center;margin:10px auto 0;background:rgba(255,255,255,.96);border:1px solid #cbd5e1;border-radius:999px;padding:5px 6px;box-shadow:0 6px 18px -4px rgba(15,23,42,.25);width:max-content}",
    ".lov-fp-zoom button{background:#fff;color:#0f172a;border:1px solid #e2e8f0;border-radius:999px;width:34px;height:34px;font-size:16px;font-weight:600;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;line-height:1;transition:background .15s,border-color .15s,color .15s}",
    ".lov-fp-zoom button:hover{background:#eff6ff;border-color:#2563eb;color:#2563eb}",
    ".lov-fp-zoom-level{font-size:10px;color:#64748b;text-align:center;font-weight:600;padding:0 4px}",
    ".lov-fp-hint{font-size:12px;color:#64748b;margin:0 4px 8px}",
    ".lov-fp-panel{background:#fff;border:1px solid #e5e7eb;border-radius:12px;padding:16px;font-size:14px;line-height:1.5;min-height:160px;transition:box-shadow .25s ease,border-color .25s ease;position:relative}",
    ".lov-fp-panel.is-preview{border-color:#93c5fd;box-shadow:0 6px 24px -8px rgba(37,99,235,.25)}",
    ".lov-fp-panel > *{animation:lovFpPanelIn .28s cubic-bezier(.16,1,.3,1) both}",
    "@keyframes lovFpPanelIn{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:translateY(0)}}",
    ".lov-fp-panel-close{position:absolute;top:10px;right:10px;width:34px;height:34px;border-radius:999px;border:1px solid #e2e8f0;background:#fff;color:#0f172a;font-size:22px;line-height:1;cursor:pointer;display:none;align-items:center;justify-content:center;padding:0;z-index:2;box-shadow:0 2px 6px rgba(15,23,42,.08)}",
    ".lov-fp-panel-close:hover{background:#f1f5f9;border-color:#2563eb;color:#2563eb}",
    ".lov-fp-drawer-backdrop{display:none;position:fixed;inset:0;background:rgba(15,23,42,.35);z-index:40;animation:lovFpFadeIn .2s ease both}",
    "@keyframes lovFpFadeIn{from{opacity:0}to{opacity:1}}",
    "@media(max-width:899px){",
    "  .lov-fp.is-drawer-open .lov-fp-drawer-backdrop{display:block}",
    "  .lov-fp-panel{position:fixed;left:0;right:0;bottom:0;z-index:50;border-radius:20px 20px 0 0;max-height:82vh;overflow-y:auto;transform:translateY(100%);transition:transform .28s cubic-bezier(.16,1,.3,1);box-shadow:0 -12px 40px -8px rgba(15,23,42,.3);padding-top:56px;padding-bottom:calc(16px + env(safe-area-inset-bottom,0px))}",
    "  .lov-fp-panel::before{content:'';position:absolute;top:10px;left:50%;transform:translateX(-50%);width:44px;height:5px;border-radius:999px;background:#cbd5e1}",
    "  .lov-fp.is-drawer-open .lov-fp-panel{transform:translateY(0)}",
    "  .lov-fp-panel-close{display:flex}",
    "}",
    ".lov-fp-panel h3{margin:0 0 4px;font-size:18px;font-weight:600}",
    ".lov-fp-panel .lov-fp-meta{font-size:12px;color:#64748b;text-transform:uppercase;letter-spacing:.08em;margin-bottom:8px}",
    ".lov-fp-panel a{color:#2563eb;text-decoration:none}",
    ".lov-fp-panel a:hover{text-decoration:underline}",
    ".lov-fp-logo{margin:10px 0;display:flex;align-items:center;justify-content:center;padding:12px;border:1px solid #e5e7eb;border-radius:12px;background:#f8fafc}",
    ".lov-fp-logo img{max-width:100%;max-height:120px;object-fit:contain;display:block}",
    ".lov-fp-share{margin-top:14px;padding:14px 16px;border:1px solid #e5e7eb;border-radius:14px;background:#f8fafc;display:flex;gap:12px;align-items:center;box-shadow:0 1px 3px rgba(15,23,42,.06)}",
    ".lov-fp-share img{width:56px;height:56px;border-radius:10px;background:#fff;flex-shrink:0}",
    ".lov-fp-share-body{font-size:12px;color:#475569;min-width:0;flex:1}",
    ".lov-fp-share-body strong{display:block;color:#0f172a;font-size:13px;margin-bottom:4px}",
    ".lov-fp-share-link{display:block;word-break:break-all;font-family:ui-monospace,SFMono-Regular,Menlo,monospace;font-size:11px;color:#2563eb;margin-bottom:6px}",
    ".lov-fp-share-btn{background:#0f172a;color:#fff;border:0;border-radius:999px;padding:7px 14px;font-size:12px;font-weight:600;cursor:pointer;transition:background .15s}",
    ".lov-fp-share-btn:hover{background:#2563eb}",
    ".lov-fp-custom-link{margin-top:14px;padding:14px 16px;border:1px solid #e5e7eb;border-radius:14px;background:#fff;display:flex;gap:12px;align-items:center;box-shadow:0 1px 3px rgba(15,23,42,.06)}",
    ".lov-fp-custom-link-body{font-size:12px;color:#475569;min-width:0;flex:1}",
    ".lov-fp-custom-link-body strong{display:block;color:#0f172a;font-size:13px;margin-bottom:4px}",
    ".lov-fp-buy{margin-top:10px;padding:14px 16px;border:1px solid #e5e7eb;border-radius:14px;background:#f8fafc;display:flex;gap:12px;align-items:center;justify-content:space-between;box-shadow:0 1px 3px rgba(15,23,42,.06)}",
    ".lov-fp-buy-body{font-size:12px;color:#475569;min-width:0;flex:1}",
    ".lov-fp-buy-body strong{display:block;color:#0f172a;font-size:13px;margin-bottom:2px}",
    ".lov-fp-panel a.lov-fp-buy-btn{background:#0f172a;color:#fff;border:0;border-radius:999px;padding:8px 16px;font-size:12px;font-weight:600;cursor:pointer;text-decoration:none;display:inline-block;white-space:nowrap;transition:background .15s}",
    ".lov-fp-panel a.lov-fp-buy-btn:hover{background:#2563eb;text-decoration:none;color:#fff}",
    ".lov-fp-empty{color:#64748b}",
    ".lov-fp-booth{cursor:pointer;transition:transform .18s cubic-bezier(.16,1,.3,1),filter .18s ease;outline:none}",
    ".lov-fp-booth:hover,.lov-fp-booth:focus-visible{transform:translateY(-2px);filter:drop-shadow(0 8px 14px rgba(37,99,235,.22))}",
    ".lov-fp-booth:hover rect.lov-fp-booth-bg,.lov-fp-booth:focus-visible rect.lov-fp-booth-bg{stroke:#2563eb;stroke-width:3}",
    ".lov-fp-booth.is-selected{filter:drop-shadow(0 10px 18px rgba(37,99,235,.35))}",
    ".lov-fp-booth.is-selected rect.lov-fp-booth-bg{fill:#dbeafe;stroke:#1d4ed8;stroke-width:4.5}",
    ".lov-fp-booth text{pointer-events:none;user-select:none}",
    ".lov-fp-route{stroke:#2563eb;stroke-width:7;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:4 12;fill:none}",
    ".lov-fp-route-glow{stroke:#2563eb;stroke-opacity:0;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;fill:none;transition:stroke-opacity .25s ease}",
    ".lov-fp-route-glow.is-preview{stroke-opacity:.2}",
    ".lov-fp-route.is-preview{stroke:#1d4ed8;stroke-width:10;animation:lovFpRoutePulse 1.1s ease-in-out infinite}",
    "@keyframes lovFpRoutePulse{0%,100%{opacity:1}50%{opacity:.45}}",

    ".lov-fp-entrance{fill:#10b981}",
    ".lov-fp-entrance-label{font-size:18px;fill:#065f46;font-weight:600}",
    ".lov-fp-walker{fill:#f59e0b;stroke:#fff;stroke-width:2.5;pointer-events:none}",
    ".lov-fp-walker-head{fill:#fbbf24;stroke:#b45309;stroke-width:1.2;pointer-events:none}",
    ".lov-fp-thought{pointer-events:none;opacity:0;transition:opacity .35s ease}",
    ".lov-fp-thought.is-visible{opacity:1}",
    ".lov-fp-thought-bubble{fill:#ffffff;stroke:#0f172a;stroke-width:2}",
    ".lov-fp-thought-tail{fill:#ffffff;stroke:#0f172a;stroke-width:2}",
    ".lov-fp-thought-text{font:600 16px ui-sans-serif,system-ui,-apple-system,Segoe UI,Roboto,sans-serif;fill:#0f172a;text-anchor:middle;dominant-baseline:middle}",
    /* editor */
    ".lov-fp.is-edit .lov-fp-map{touch-action:none}",
    ".lov-fp.is-edit .lov-fp-map svg{touch-action:none}",
    ".lov-fp.is-edit .lov-fp-booth{cursor:grab;touch-action:none}",
    ".lov-fp.is-edit .lov-fp-booth.is-dragging{cursor:grabbing}",
    ".lov-fp-resize{fill:#2563eb;cursor:nwse-resize;touch-action:none}",
    /* spotlights (event-exclusive callouts) */
    ".lov-fp-spotlight-card{position:relative;background:rgba(255,255,255,.97);border:1px solid #f59e0b;border-radius:10px;box-shadow:0 10px 24px -8px rgba(15,23,42,.28);padding:8px;display:flex;gap:8px;align-items:center;font-family:ui-sans-serif,system-ui,-apple-system,Segoe UI,Roboto,sans-serif;color:#0f172a;pointer-events:auto;max-width:240px}",
    ".lov-fp-spotlight-card::after{content:'';position:absolute;left:50%;bottom:-7px;transform:translateX(-50%) rotate(45deg);width:12px;height:12px;background:rgba(255,255,255,.97);border-right:1px solid #f59e0b;border-bottom:1px solid #f59e0b}",
    ".lov-fp-spotlight-card.is-below::after{bottom:auto;top:-7px;border-right:0;border-bottom:0;border-left:1px solid #f59e0b;border-top:1px solid #f59e0b}",
    ".lov-fp-spotlight-thumb{width:100px;height:100px;flex-shrink:0;border-radius:8px;object-fit:cover;background:#fef3c7;border:1px solid #fde68a}",
    ".lov-fp-spotlight-body{min-width:0;flex:1;display:flex;flex-direction:column;gap:2px}",
    ".lov-fp-spotlight-eyebrow{font-size:9px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:#b45309;line-height:1.1}",
    ".lov-fp-spotlight-title{font-size:13px;font-weight:600;line-height:1.15;margin:0;color:#0f172a;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical}",
    ".lov-fp-spotlight-text{font-size:11px;line-height:1.3;color:#475569;margin:0;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}",
    ".lov-fp-spotlight-nav{margin-top:4px;background:#f59e0b;color:#0f172a;border:0;border-radius:5px;padding:3px 8px;font-size:11px;font-weight:600;cursor:pointer;align-self:flex-start}",
    ".lov-fp-spotlight-nav:hover{background:#d97706;color:#fff}",
    ".lov-fp-spotlight-star{cursor:pointer;transform-origin:center;transform-box:fill-box;animation:lovFpSpotPulse 2.4s ease-in-out infinite}",
    "@keyframes lovFpSpotPulse{0%,100%{transform:scale(1);filter:drop-shadow(0 0 2px rgba(245,158,11,.35))}50%{transform:scale(1.12);filter:drop-shadow(0 0 14px rgba(245,158,11,.95))}}",

    ".lov-fp-toolbar{display:flex;flex-wrap:wrap;gap:8px;align-items:center;margin:0 0 10px;padding:8px;background:#f8fafc;border:1px solid #e5e7eb;border-radius:8px;font-size:13px}",
    ".lov-fp-toolbar button{background:#2563eb;color:#fff;border:0;border-radius:6px;padding:6px 12px;font-size:13px;cursor:pointer;font-weight:500}",
    ".lov-fp-toolbar button.secondary{background:#fff;color:#0f172a;border:1px solid #cbd5e1}",
    ".lov-fp-toolbar button:hover{opacity:.9}",
    ".lov-fp-toolbar .lov-fp-status{color:#64748b;margin-left:auto;font-size:12px}",
    ".lov-fp-export{position:fixed;inset:0;background:rgba(15,23,42,.6);display:flex;align-items:center;justify-content:center;z-index:9999;padding:20px}",
    ".lov-fp-export-card{background:#fff;border-radius:12px;padding:20px;max-width:720px;width:100%;max-height:80vh;display:flex;flex-direction:column;gap:12px}",
    ".lov-fp-export-card h3{margin:0;font-size:18px}",
    ".lov-fp-export-card textarea{flex:1;min-height:300px;font-family:ui-monospace,SFMono-Regular,Menlo,monospace;font-size:12px;border:1px solid #cbd5e1;border-radius:6px;padding:10px;resize:vertical}",
    ".lov-fp-export-card .lov-fp-row{display:flex;gap:8px;justify-content:flex-end}",
    /* search */
    ".lov-fp-search{position:relative;grid-column:1/-1;margin:0 0 4px}",
    ".lov-fp-search-input-wrap{position:relative;display:flex;align-items:center}",
    ".lov-fp-search input{width:100%;padding:9px 34px 9px 34px;border:1px solid #cbd5e1;border-radius:8px;font-size:14px;background:#fff;color:#0f172a;outline:none;transition:border-color .15s,box-shadow .15s}",
    ".lov-fp-search input:focus{border-color:#2563eb;box-shadow:0 0 0 3px rgba(37,99,235,.15)}",
    ".lov-fp-search-icon{position:absolute;left:10px;top:50%;transform:translateY(-50%);width:16px;height:16px;color:#94a3b8;pointer-events:none}",
    ".lov-fp-search-clear{position:absolute;right:6px;top:50%;transform:translateY(-50%);width:24px;height:24px;border:0;background:transparent;color:#64748b;font-size:18px;cursor:pointer;border-radius:4px;display:none;align-items:center;justify-content:center;line-height:1;padding:0}",
    ".lov-fp-search-clear:hover{background:#f1f5f9;color:#0f172a}",
    ".lov-fp-search.has-query .lov-fp-search-clear{display:flex}",
    ".lov-fp-search-results{position:absolute;top:100%;left:0;right:0;margin-top:4px;background:#fff;border:1px solid #cbd5e1;border-radius:8px;box-shadow:0 10px 24px -8px rgba(15,23,42,.25);max-height:240px;overflow-y:auto;z-index:8;display:none}",
    ".lov-fp-search.is-open .lov-fp-search-results{display:block}",
    ".lov-fp-search-result{padding:8px 12px;cursor:pointer;font-size:13px;border-bottom:1px solid #f1f5f9;display:flex;align-items:center;gap:8px}",
    ".lov-fp-search-result:last-child{border-bottom:0}",
    ".lov-fp-search-result:hover,.lov-fp-search-result.is-active{background:#eff6ff}",
    ".lov-fp-search-result-num{font-weight:600;color:#0f172a;min-width:28px}",
    ".lov-fp-search-result-name{color:#475569;flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}",
    ".lov-fp-search-result-cat{font-size:11px;color:#64748b;background:#f1f5f9;padding:2px 6px;border-radius:10px;white-space:nowrap}",
    ".lov-fp-search-empty{padding:10px 12px;font-size:13px;color:#94a3b8;text-align:center}",
    /* legend */
    ".lov-fp-legend{display:flex;flex-wrap:wrap;gap:6px;justify-content:center;align-items:center;margin:6px 0 0;grid-column:1/-1}",
    ".lov-fp-chip{display:inline-flex;align-items:center;gap:6px;padding:4px 10px;border:1px solid #cbd5e1;border-radius:999px;background:#fff;font-size:12px;color:#475569;cursor:pointer;font-weight:500;transition:all .15s;user-select:none}",
    ".lov-fp-chip:hover{border-color:#2563eb;color:#0f172a}",
    ".lov-fp-chip.is-active{background:#0f172a;color:#fff;border-color:#0f172a}",
    ".lov-fp-chip.is-active .lov-fp-chip-count{background:rgba(255,255,255,.2);color:#fff}",
    ".lov-fp-chip-swatch{width:10px;height:10px;border-radius:3px;flex-shrink:0;border:1px solid rgba(15,23,42,.15)}",
    ".lov-fp-chip-count{font-size:10px;background:#f1f5f9;color:#64748b;padding:1px 6px;border-radius:8px;font-weight:600;min-width:18px;text-align:center}",
    ".lov-fp-chip-all{font-weight:600}",
    /* match/filter states */
    ".lov-fp-booth.is-dimmed{opacity:.22;pointer-events:none}",
    ".lov-fp-booth.is-cat-hidden{opacity:.1;pointer-events:none}",
    ".lov-fp-booth.is-day-hidden{opacity:.12;pointer-events:none}",
    ".lov-fp-booth.is-day-shadowed{display:none}",
    ".lov-fp-days{grid-column:1/-1;display:flex;align-items:center;gap:8px;margin:0 0 8px;flex-wrap:wrap}",
    ".lov-fp-days-label{font-size:12px;font-weight:600;color:#64748b;text-transform:uppercase;letter-spacing:.04em}",
    ".lov-fp-days-group{display:inline-flex;background:#f1f5f9;border:1px solid #cbd5e1;border-radius:999px;padding:3px;gap:2px}",
    ".lov-fp-day{border:0;background:transparent;color:#475569;font-size:13px;font-weight:600;padding:6px 14px;border-radius:999px;cursor:pointer;transition:background .15s,color .15s}",
    ".lov-fp-day:hover{color:#0f172a}",
    ".lov-fp-day.is-active{background:#fff;color:#0f172a;box-shadow:0 1px 3px rgba(15,23,42,.18)}",
    ".lov-fp-days-note{font-size:12px;color:#64748b}",
    ".lov-fp-avail{display:inline-flex;align-items:center;gap:8px;margin:2px 0 8px;padding:6px 12px;border-radius:999px;font-size:14px;font-weight:700;border:1.5px solid}",
    ".lov-fp-avail-dot{width:10px;height:10px;border-radius:50%;flex:none}",
    ".lov-fp-avail--both{background:#ecfdf5;border-color:#34d399;color:#047857}",
    ".lov-fp-avail--both .lov-fp-avail-dot{background:#10b981}",
    ".lov-fp-avail--sat{background:#eff6ff;border-color:#60a5fa;color:#1d4ed8}",
    ".lov-fp-avail--sat .lov-fp-avail-dot{background:#3b82f6}",
    ".lov-fp-avail--sun{background:#fff7ed;border-color:#fb923c;color:#c2410c}",
    ".lov-fp-avail--sun .lov-fp-avail-dot{background:#f97316}",
    "@media print{.lov-fp-avail{display:none}}",
    "@media print{.lov-fp-days-group{border-color:#000}.lov-fp-day:not(.is-active){display:none}}",
    ".lov-fp-booth.is-match rect.lov-fp-booth-bg{stroke:#f59e0b;stroke-width:4}",
    ".lov-fp-booth.is-match{animation:lovFpMatchPulse 1.6s ease-in-out infinite}",
    "@keyframes lovFpMatchPulse{0%,100%{filter:drop-shadow(0 0 0 rgba(245,158,11,0))}50%{filter:drop-shadow(0 0 8px rgba(245,158,11,.55))}}",
    /* page chrome rendered by widget (replaces the React wrapper) */
    ".lov-fp-page{min-height:100vh;background:#fff;color:#0f172a;font-family:ui-sans-serif,system-ui,-apple-system,Segoe UI,Roboto,sans-serif}",
    ".lov-fp-header{border-bottom:1px solid #e5e7eb}",
    ".lov-fp-header-inner{max-width:1152px;margin:0 auto;padding:24px 16px;display:flex;align-items:flex-start;justify-content:space-between;gap:16px}",
    ".lov-fp-eyebrow{font-size:11px;font-weight:500;text-transform:uppercase;letter-spacing:.18em;color:#64748b;margin:0}",
    ".lov-fp-title{margin:4px 0 0;font-size:30px;font-weight:600;letter-spacing:-.02em;color:#0f172a}",
    "@media(min-width:640px){.lov-fp-title{font-size:36px}}",
    ".lov-fp-subtitle{margin:8px 0 0;font-size:14px;color:#64748b;max-width:42rem}",
    ".lov-fp-edit-toggle{flex-shrink:0;border:1px solid #e5e7eb;background:#fff;color:#0f172a;border-radius:6px;padding:8px 12px;font-size:14px;font-weight:500;cursor:pointer;transition:background-color .15s,border-color .15s,color .15s}",
    ".lov-fp-edit-toggle:hover{background:#f1f5f9}",
    ".lov-fp-edit-toggle.is-on{background:#2563eb;border-color:#2563eb;color:#fff}",
    ".lov-fp-main{max-width:1152px;margin:0 auto;padding:24px 16px}",
  ].join("");

  // Category color palette. Keys are lower-cased category names.
  var CATEGORY_COLORS = {
    automation: "#3b82f6",
    hardware: "#8b5cf6",
    software: "#06b6d4",
    food: "#ef4444",
    beverage: "#f59e0b",
    services: "#10b981",
    sponsor: "#ec4899",
    media: "#6366f1",
    education: "#14b8a6",
    uncategorized: "#94a3b8",
  };
  var FALLBACK_PALETTE = ["#22c55e", "#f97316", "#0ea5e9", "#a855f7", "#eab308", "#ef4444", "#14b8a6", "#d946ef"];
  function categoryKey(v) {
    return String((v && v.category) || "Uncategorized").trim() || "Uncategorized";
  }
  // Which show days a vendor occupies its table. Supports:
  //   days: ["sat","sun"] | "saturday" | "sat,sun"
  //   saturday: true/false, sunday: true/false
  // Missing info means the booth is used on both days.
  function vendorDays(v) {
    var out = { sat: false, sun: false };
    var raw = v && v.days;
    var list = null;
    if (Array.isArray(raw)) list = raw;
    else if (typeof raw === "string" && raw.trim()) list = raw.split(/[,\s/|]+/);
    if (list && list.length) {
      for (var i = 0; i < list.length; i++) {
        var d = String(list[i]).trim().toLowerCase();
        if (d.indexOf("sat") === 0) out.sat = true;
        if (d.indexOf("sun") === 0) out.sun = true;
        if (d === "both" || d === "all") {
          out.sat = true;
          out.sun = true;
        }
      }
    } else if (v && (typeof v.saturday === "boolean" || typeof v.sunday === "boolean")) {
      out.sat = v.saturday !== false;
      out.sun = v.sunday !== false;
    } else {
      out.sat = true;
      out.sun = true;
    }
    if (!out.sat && !out.sun) {
      out.sat = true;
      out.sun = true;
    }
    return out;
  }
  function vendorDaysLabel(v) {
    var d = vendorDays(v);
    if (d.sat && d.sun) return "Saturday & Sunday";
    return d.sat ? "Saturday only" : "Sunday only";
  }
  function colorForCategory(cat, idx) {
    var key = cat.toLowerCase();
    if (CATEGORY_COLORS[key]) return CATEGORY_COLORS[key];
    return FALLBACK_PALETTE[idx % FALLBACK_PALETTE.length];
  }
  // Mix a hex color with white to produce a soft fill tint. amount 0..1 (1 = pure white).
  function tintColor(hex, amount) {
    var h = hex.replace("#", "");
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    var r = parseInt(h.slice(0, 2), 16),
      g = parseInt(h.slice(2, 4), 16),
      b = parseInt(h.slice(4, 6), 16);
    var t = Math.max(0, Math.min(1, amount));
    r = Math.round(r + (255 - r) * t);
    g = Math.round(g + (255 - g) * t);
    b = Math.round(b + (255 - b) * t);
    return (
      "#" +
      [r, g, b]
        .map(function (n) {
          return n.toString(16).padStart(2, "0");
        })
        .join("")
    );
  }

  function ensureStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement("style");
    s.id = STYLE_ID;
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function el(tag, attrs, children) {
    var n = document.createElementNS(SVG_NS, tag);
    if (attrs) for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (children) for (var i = 0; i < children.length; i++) n.appendChild(children[i]);
    return n;
  }
  function html(tag, attrs, text) {
    var n = document.createElement(tag);
    if (attrs) for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (text != null) n.textContent = text;
    return n;
  }
  function cellCenter(col, row) {
    return { x: PAD + (col - 0.5) * CELL, y: PAD + (row - 0.5) * CELL };
  }
  function boothBox(v) {
    var col = +v.col,
      row = +v.row;
    var w = Math.max(1, +v.w || 1);
    var h = Math.max(1, +v.h || 1);
    return {
      x: PAD + (col - 1) * CELL + 1,
      y: PAD + (row - 1) * CELL + 1,
      w: w * CELL - 2,
      h: h * CELL - 2,
      cx: PAD + (col - 1 + w / 2) * CELL,
      cy: PAD + (row - 1 + h / 2) * CELL,
    };
  }
  function boothCenter(v) {
    var b = boothBox(v);
    return { x: b.cx, y: b.cy };
  }

  function computePath(vendors, selected, origin) {
    if (!selected) return null;
    origin = origin && isFinite(+origin.col) && isFinite(+origin.row) ? origin : ENTRANCE;
    var occupied = {};
    var selCol = +selected.col,
      selRow = +selected.row;
    for (var i = 0; i < vendors.length; i++) {
      var v = vendors[i];
      if (v.id === selected.id) continue;
      var vCol = +v.col,
        vRow = +v.row;
      var w = Math.max(1, +v.w || 1),
        h = Math.max(1, +v.h || 1);
      for (var dx = 0; dx < w; dx++)
        for (var dy = 0; dy < h; dy++) {
          occupied[vCol + dx + "," + (vRow + dy)] = true;
        }
    }
    // pick any cell of selected as target (top-left)
    var targetKey = selCol + "," + selRow;
    // The BFS starts at the in-grid cell closest to the origin door/entrance —
    // NOT a hardcoded bottom row. A door on the top edge therefore enters the
    // grid at row 1, a side door at col 1 / COLS, and so on.
    var oCol = +origin.col,
      oRow = +origin.row;
    var onSide = oCol < 1 || oCol > COLS; // left/right edge door
    var start = null;
    var maxSpan = onSide ? ROWS : COLS;
    for (var d = 0; d < maxSpan && !start; d++) {
      var base = onSide ? Math.min(ROWS, Math.max(1, Math.round(oRow))) : Math.min(COLS, Math.max(1, Math.round(oCol)));
      var cands = [base - d, base + d];
      for (var j = 0; j < cands.length; j++) {
        var c = cands[j];
        var sc, sr;
        if (onSide) {
          if (c < 1 || c > ROWS) continue;
          sc = oCol < 1 ? 1 : COLS;
          sr = c;
        } else {
          if (c < 1 || c > COLS) continue;
          sc = c;
          sr = oRow < 1 ? 1 : oRow > ROWS ? ROWS : Math.min(ROWS, Math.max(1, Math.round(oRow)));
        }
        var k = sc + "," + sr;
        if (!occupied[k] && !WALL_CELLS[k]) {
          start = { col: sc, row: sr };
          break;
        }
      }
    }
    if (!start) return null;

    var cameFrom = {};
    var startKey = start.col + "," + start.row;
    cameFrom[startKey] = null;
    var queue = [start];
    var dirs = [
      [1, 0],
      [-1, 0],
      [0, 1],
      [0, -1],
    ];
    // also accept arriving at any cell adjacent to the selected booth
    var sw = Math.max(1, +selected.w || 1),
      sh = Math.max(1, +selected.h || 1);
    var targetCells = {};
    for (var tx = 0; tx < sw; tx++)
      for (var ty = 0; ty < sh; ty++) {
        targetCells[selCol + tx + "," + (selRow + ty)] = true;
      }
    var found = null;
    while (queue.length) {
      var cur = queue.shift();
      var curKey = cur.col + "," + cur.row;
      if (targetCells[curKey]) {
        found = curKey;
        break;
      }
      for (var di = 0; di < 4; di++) {
        var nc = cur.col + dirs[di][0];
        var nr = cur.row + dirs[di][1];
        if (nc < 1 || nc > COLS || nr < 1 || nr > ROWS) continue;
        var nk = nc + "," + nr;
        if (nk in cameFrom) continue;
        if (occupied[nk] && !targetCells[nk]) continue;
        if (WALL_CELLS[nk] && !targetCells[nk]) continue;
        cameFrom[nk] = curKey;
        queue.push({ col: nc, row: nr });
      }
    }
    if (!found) return null;
    var cells = [];
    var cur2 = found;
    while (cur2) {
      cells.unshift(cur2);
      cur2 = cameFrom[cur2];
    }
    // Drop trailing cells that fall inside the selected booth so walkers
    // stop at the table edge instead of stepping onto the table itself.
    while (cells.length > 1 && targetCells[cells[cells.length - 1]]) cells.pop();
    var entrancePt = cellCenter(oCol, oRow);
    var pts = [entrancePt];

    for (var ci = 0; ci < cells.length; ci++) {
      var parts = cells[ci].split(",");
      pts.push(cellCenter(+parts[0], +parts[1]));
    }
    // Collision buffer: scales with the current cell size so walkers keep
    // clear of every lov-fp-booth-bg rect regardless of booth dimensions
    // or zoom. Tuned to ~18% of a cell with a small absolute floor.
    var BUFFER = Math.max(6, Math.round(CELL * 0.18));

    // Push a point outside a booth rect, padded by BUFFER. If the point is
    // inside (or within BUFFER of) the rect, snap it to the nearest edge
    // along the shorter axis. Returns a new point.
    function pushOutside(p, rect) {
      var minX = rect.x - BUFFER,
        maxX = rect.x + rect.w + BUFFER,
        minY = rect.y - BUFFER,
        maxY = rect.y + rect.h + BUFFER;
      if (p.x <= minX || p.x >= maxX || p.y <= minY || p.y >= maxY) return p;
      var dl = p.x - minX,
        dr = maxX - p.x,
        dt = p.y - minY,
        db = maxY - p.y;
      var m = Math.min(dl, dr, dt, db);
      if (m === dl) return { x: minX, y: p.y };
      if (m === dr) return { x: maxX, y: p.y };
      if (m === dt) return { x: p.x, y: minY };
      return { x: p.x, y: maxY };
    }

    // Final waypoint: nearest point on the selected booth's padded edge.
    var bb = boothBox(selected);
    var approach = pts[pts.length - 1];
    var ex = Math.max(bb.x, Math.min(bb.x + bb.w, approach.x));
    var ey = Math.max(bb.y, Math.min(bb.y + bb.h, approach.y));
    var insideX = ex > bb.x && ex < bb.x + bb.w;
    var insideY = ey > bb.y && ey < bb.y + bb.h;
    if (insideX && insideY) {
      var dl2 = ex - bb.x,
        dr2 = bb.x + bb.w - ex,
        dt2 = ey - bb.y,
        db2 = bb.y + bb.h - ey;
      var m2 = Math.min(dl2, dr2, dt2, db2);
      if (m2 === dl2) ex = bb.x;
      else if (m2 === dr2) ex = bb.x + bb.w;
      else if (m2 === dt2) ey = bb.y;
      else ey = bb.y + bb.h;
    }
    if (ex <= bb.x) ex = bb.x - BUFFER;
    else if (ex >= bb.x + bb.w) ex = bb.x + bb.w + BUFFER;
    if (ey <= bb.y) ey = bb.y - BUFFER;
    else if (ey >= bb.y + bb.h) ey = bb.y + bb.h + BUFFER;
    pts.push({ x: ex, y: ey });

    // Sweep every waypoint against every booth rect so the dotted line and
    // walkers never overlap a booth background, even if booth sizes change.
    var boothRects = [];
    for (var bi = 0; bi < vendors.length; bi++) boothRects.push(boothBox(vendors[bi]));
    for (var pi = 1; pi < pts.length; pi++) {
      var moved = true,
        guard = 0;
      while (moved && guard++ < 4) {
        moved = false;
        for (var ri = 0; ri < boothRects.length; ri++) {
          var np = pushOutside(pts[pi], boothRects[ri]);
          if (np.x !== pts[pi].x || np.y !== pts[pi].y) {
            pts[pi] = np;
            moved = true;
          }
        }
      }
    }

    return pts
      .map(function (p, idx) {
        return (idx === 0 ? "M" : "L") + " " + p.x + " " + p.y;
      })
      .join(" ");
  }

  function render(container, vendors, opts) {
    opts = opts || {};
    // Ensure unique ids — two vendors sharing a booth name/id on different
    // days must not overwrite each other (otherwise the Saturday-only one
    // can linger on Sunday).
    (function () {
      var seen = {};
      for (var ui = 0; ui < vendors.length; ui++) {
        var uv = vendors[ui];
        var base = String(uv.id || uv.booth || "booth-" + (ui + 1));
        var uid = base;
        if (seen[uid]) {
          var dd = vendorDays(uv);
          uid = base + "-" + (dd.sat && !dd.sun ? "sat" : dd.sun && !dd.sat ? "sun" : ui + 1);
          var n = 2;
          while (seen[uid]) uid = base + "-" + n++;
        }
        seen[uid] = true;
        uv.id = uid;
        if (!uv.booth) uv.booth = base;
      }
    })();
    var editable = !!opts.editable;
    container.innerHTML = "";
    container.classList.add("lov-fp");
    if (editable) container.classList.add("is-edit");

    var mapWrap = html("div", { class: "lov-fp-map" });

    var statusEl = null;
    if (editable) {
      var bar = html("div", { class: "lov-fp-toolbar" });
      var saveBtn = html("button", null, "Save");
      var printBtn = html("button", { class: "secondary" }, "Print");
      var exportBtn = html("button", { class: "secondary" }, "Export JSON");
      var addBtn = html("button", null, "+ Add booth");
      var removeBtn = html("button", { class: "secondary" }, "Remove selected");
      var regenBtn = html("button", { class: "secondary" }, "Regenerate defaults");
      var resetBtn = html("button", { class: "secondary" }, "Reset");
      statusEl = html("span", { class: "lov-fp-status" }, "Drag booths to move. Drag the blue corner to resize.");
      // Inline grid-size inputs. Changing either re-mounts the widget with
      // the new dimensions; clicking Save persists them per-browser.
      var sizeWrap = html("span", {
        class: "lov-fp-size",
        style: "display:inline-flex;align-items:center;gap:6px;font-size:12px;color:#334155;margin-right:4px",
      });
      sizeWrap.appendChild(html("span", null, "Grid:"));
      var colsInput = html("input", {
        type: "number",
        min: "1",
        max: "60",
        step: "1",
        value: String(COLS),
        "aria-label": "Number of columns",
        style: "width:56px;padding:4px 6px;border:1px solid #cbd5e1;border-radius:4px;font-size:12px",
      });
      var rowsInput = html("input", {
        type: "number",
        min: "1",
        max: "60",
        step: "1",
        value: String(ROWS),
        "aria-label": "Number of rows",
        style: "width:56px;padding:4px 6px;border:1px solid #cbd5e1;border-radius:4px;font-size:12px",
      });
      sizeWrap.appendChild(colsInput);
      sizeWrap.appendChild(html("span", null, "\u00d7"));
      sizeWrap.appendChild(rowsInput);
      bar.appendChild(sizeWrap);

      // Background picker
      var bgWrap = html("span", {
        class: "lov-fp-bg",
        style: "display:inline-flex;align-items:center;gap:6px;font-size:12px;color:#334155;margin-right:4px",
      });
      bgWrap.appendChild(html("span", null, "Floor:"));
      var bgSelect = html("select", {
        "aria-label": "Floor background",
        style: "padding:4px 6px;border:1px solid #cbd5e1;border-radius:4px;font-size:12px;background:#fff",
      });
      var bgKeys = [
        "none",
        "carpet-red",
        "carpet-blue",
        "carpet-gray",
        "wood",
        "checker",
        "concrete",
        "grid",
        "custom",
      ];
      var currentBg =
        opts.background && opts.background.type === "image"
          ? "custom"
          : (opts.background && opts.background.value) || "none";
      bgKeys.forEach(function (k) {
        var o = html("option", { value: k }, k === "custom" ? "Custom image URL…" : BG_LABELS[k] || k);
        if (k === currentBg) o.setAttribute("selected", "");
        bgSelect.appendChild(o);
      });
      bgWrap.appendChild(bgSelect);
      bar.appendChild(bgWrap);
      bgSelect.addEventListener("change", function () {
        var v = bgSelect.value;
        var next = { type: "none", value: "", color: (opts.background && opts.background.color) || "" };
        if (v === "custom") {
          var url = window.prompt("Image URL for the floor background (leave blank to cancel):", "");
          if (!url) {
            bgSelect.value = currentBg;
            return;
          }
          next = { type: "image", value: url, color: next.color };
        } else if (v !== "none") {
          next = { type: "preset", value: v, color: next.color };
        }
        try {
          if (opts.bgStorageKey) localStorage.setItem(opts.bgStorageKey, JSON.stringify(next));
        } catch (_) {}
        container.__lovFpMounted = false;
        container.innerHTML = "";
        mount(container);
      });

      bar.appendChild(addBtn);
      bar.appendChild(removeBtn);
      bar.appendChild(saveBtn);
      bar.appendChild(printBtn);
      bar.appendChild(exportBtn);
      bar.appendChild(regenBtn);
      bar.appendChild(resetBtn);
      bar.appendChild(statusEl);
      mapWrap.appendChild(bar);

      function applyGridSize() {
        var nc = Math.max(1, Math.min(60, parseInt(colsInput.value, 10) || COLS));
        var nr = Math.max(1, Math.min(60, parseInt(rowsInput.value, 10) || ROWS));
        if (nc === COLS && nr === ROWS) return;
        try {
          if (opts.gridStorageKey) {
            localStorage.setItem(opts.gridStorageKey, JSON.stringify({ cols: nc, rows: nr }));
          }
        } catch (_) {}
        // Clamp the entrance into the new grid so it doesn't disappear.
        if (ENTRANCE.col > nc + 0.5) ENTRANCE.col = Math.ceil(nc / 2);
        if (ENTRANCE.row > nr + 0.5) ENTRANCE.row = nr + 0.5;
        COLS = nc;
        ROWS = nr;
        W = COLS * CELL + PAD * 2;
        H = ROWS * CELL + PAD * 2;
        // Remount with current (in-memory) vendor list preserved.
        container.__lovFpMounted = false;
        container.innerHTML = "";
        // Stash the working vendor list so mount() picks it up as "saved".
        try {
          if (opts.storageKey) localStorage.setItem(opts.storageKey, JSON.stringify(vendors));
        } catch (_) {}
        mount(container);
      }
      colsInput.addEventListener("change", applyGridSize);
      rowsInput.addEventListener("change", applyGridSize);
      saveBtn.addEventListener("click", function () {
        try {
          var key = opts.storageKey || "lov-fp:vendors";
          localStorage.setItem(key, JSON.stringify(vendors));
          if (opts.entranceStorageKey) {
            localStorage.setItem(opts.entranceStorageKey, JSON.stringify({ col: ENTRANCE.col, row: ENTRANCE.row }));
          }
          if (statusEl) statusEl.textContent = "Saved " + vendors.length + " booths + entrance to this browser.";
          saveBtn.textContent = "Saved!";
          setTimeout(function () {
            saveBtn.textContent = "Save";
          }, 1500);
        } catch (err) {
          if (statusEl)
            statusEl.textContent = "Save failed: " + (err && err.message ? err.message : "storage unavailable");
        }
      });
      printBtn.addEventListener("click", function () {
        printFloorPlan(svg, opts, state.selected, vendors, filterState && filterState.day);
      });
      exportBtn.addEventListener("click", function () {
        showExport(vendors);
      });

      addBtn.addEventListener("click", function () {
        // Find the first empty 1x1 cell.
        var taken = {};
        for (var i = 0; i < vendors.length; i++) {
          var o = vendors[i];
          var ow = Math.max(1, +o.w || 1),
            oh = Math.max(1, +o.h || 1);
          for (var dx = 0; dx < ow; dx++)
            for (var dy = 0; dy < oh; dy++) taken[+o.col + dx + "," + (+o.row + dy)] = true;
        }
        var spot = null;
        for (var r = 1; r <= ROWS && !spot; r++)
          for (var c = 1; c <= COLS && !spot; c++) if (!taken[c + "," + r]) spot = { col: c, row: r };
        if (!spot) {
          if (statusEl) statusEl.textContent = "No empty cell available — resize or remove a booth first.";
          return;
        }
        // Generate a unique id and booth number.
        var maxN = 0;
        for (var k = 0; k < vendors.length; k++) {
          var m = /(\d+)$/.exec(vendors[k].id || "");
          if (m) maxN = Math.max(maxN, +m[1]);
        }
        var n = maxN + 1;
        var nv = {
          id: "T" + n,
          booth: String(n),
          name: "New Booth " + n,
          category: "Uncategorized",
          description: "Add a short description for this vendor.",
          col: spot.col,
          row: spot.row,
          w: 1,
          h: 1,
        };
        vendors.push(nv);
        rebuild();
        select(nv.id);
        if (statusEl) statusEl.textContent = "Added " + nv.id + " at col " + spot.col + ", row " + spot.row + ".";
      });
      removeBtn.addEventListener("click", function () {
        var sel = state.selected;
        if (!sel) {
          if (statusEl) statusEl.textContent = "Select a booth first, then click Remove.";
          return;
        }
        if (!confirm("Remove booth " + (sel.booth || sel.id) + "?")) return;
        for (var i = 0; i < vendors.length; i++) {
          if (vendors[i].id === sel.id) {
            vendors.splice(i, 1);
            break;
          }
        }
        state.selected = null;
        rebuild();
        showEntrance();
        if (statusEl) statusEl.textContent = "Removed " + (sel.booth || sel.id) + ".";
      });
      resetBtn.addEventListener("click", function () {
        if (!confirm("Reset all positions to the originally loaded layout?")) return;
        vendors.length = 0;
        for (var i = 0; i < opts.initial.length; i++) vendors.push(JSON.parse(JSON.stringify(opts.initial[i])));
        rebuild();
      });
      regenBtn.addEventListener("click", function () {
        if (!confirm("Replace all vendors with the built-in defaults? Your current layout will be lost.")) return;
        vendors.length = 0;
        for (var j = 0; j < DEFAULT_VENDORS.length; j++) vendors.push(JSON.parse(JSON.stringify(DEFAULT_VENDORS[j])));
        rebuild();
        if (statusEl) statusEl.textContent = "Loaded " + DEFAULT_VENDORS.length + " default vendors.";
      });
    } else {
      var hintRow = html("div", {
        style: "display:flex;align-items:center;justify-content:space-between;gap:8px;margin:0 4px 8px",
      });
      hintRow.appendChild(
        html(
          "p",
          { class: "lov-fp-hint", style: "margin:0" },
          "Tap a table to view vendor details and route from the entrance.",
        ),
      );
      var viewPrintBtn = html(
        "button",
        {
          type: "button",
          style:
            "background:#0f172a;color:#fff;border:0;border-radius:6px;padding:6px 12px;font-size:12px;cursor:pointer;font-weight:500",
        },
        "Print",
      );
      viewPrintBtn.addEventListener("click", function () {
        printFloorPlan(svg, opts, state.selected, vendors, filterState && filterState.day);
      });
      hintRow.appendChild(viewPrintBtn);
      mapWrap.appendChild(hintRow);
    }

    var svg = el("svg", {
      viewBox: "0 0 " + W + " " + H,
      preserveAspectRatio: "xMidYMid meet",
      role: "img",
      "aria-label": "Tradeshow floor plan",
      style: "width:100%;height:auto;max-width:100%",
    });
    mapWrap.appendChild(svg);
    renderBackground(svg, opts.background);

    // Zoom controls
    var zoom = 1;
    var ZOOM_MIN = 0.5,
      ZOOM_MAX = 3,
      ZOOM_STEP = 0.25;
    var zoomBox = html("div", { class: "lov-fp-zoom", "aria-label": "Zoom controls" });
    var zoomInBtn = html("button", { type: "button", "aria-label": "Zoom in", title: "Zoom in" }, "+");
    var zoomLevel = html("div", { class: "lov-fp-zoom-level" }, "100%");
    var zoomOutBtn = html("button", { type: "button", "aria-label": "Zoom out", title: "Zoom out" }, "\u2212");
    var zoomResetBtn = html(
      "button",
      { type: "button", "aria-label": "Reset zoom", title: "Reset zoom", style: "font-size:11px" },
      "1:1",
    );
    zoomBox.appendChild(zoomInBtn);
    zoomBox.appendChild(zoomOutBtn);
    zoomBox.appendChild(zoomLevel);
    zoomBox.appendChild(zoomResetBtn);

    // Anchor a zoom change at viewport point (cx, cy) in mapWrap-client coords.
    // Keeps the content under that point stationary while zooming.
    function applyZoom(anchorX, anchorY) {
      var prevZoom = parseFloat(svg.dataset.lovZoom || "1") || 1;
      zoom = Math.max(ZOOM_MIN, Math.min(ZOOM_MAX, zoom));
      var pct = Math.round(zoom * 100);
      zoomLevel.textContent = pct + "%";

      var cx = typeof anchorX === "number" ? anchorX : mapWrap.clientWidth / 2;
      var cy = typeof anchorY === "number" ? anchorY : mapWrap.clientHeight / 2;
      var contentX = mapWrap.scrollLeft + cx;
      var contentY = mapWrap.scrollTop + cy;

      if (zoom === 1) {
        svg.style.width = "";
        svg.style.minWidth = "";
        svg.style.maxWidth = "100%";
      } else {
        svg.style.width = pct + "%";
        svg.style.minWidth = pct + "%";
        svg.style.maxWidth = "none";
      }
      svg.dataset.lovZoom = String(zoom);

      var ratio = zoom / prevZoom;
      requestAnimationFrame(function () {
        mapWrap.scrollLeft = contentX * ratio - cx;
        mapWrap.scrollTop = contentY * ratio - cy;
      });
    }
    zoomInBtn.addEventListener("click", function () {
      zoom += ZOOM_STEP;
      applyZoom();
    });
    zoomOutBtn.addEventListener("click", function () {
      zoom -= ZOOM_STEP;
      applyZoom();
    });
    zoomResetBtn.addEventListener("click", function () {
      zoom = 1;
      applyZoom();
    });

    // Default to 200% zoom on mobile-sized viewports.
    try {
      if (typeof window !== "undefined" && window.innerWidth && window.innerWidth < 768) {
        zoom = 2;
        requestAnimationFrame(function () {
          applyZoom();
        });
      }
    } catch (_e) {}

    // ---- Trackpad / wheel pinch-zoom (Ctrl+wheel = trackpad pinch) -----
    mapWrap.addEventListener(
      "wheel",
      function (e) {
        if (!e.ctrlKey) return;
        e.preventDefault();
        var rect = mapWrap.getBoundingClientRect();
        var ax = e.clientX - rect.left;
        var ay = e.clientY - rect.top;
        var factor = Math.exp(-e.deltaY * 0.01);
        zoom = zoom * factor;
        applyZoom(ax, ay);
      },
      { passive: false },
    );

    // ---- Touch pinch-to-zoom + drag-to-pan -----------------------------
    // Single-finger pan delegates to the browser (touch-action:pan-x pan-y)
    // so it can scroll the map and, at the edges, overscroll the page. We
    // only track touches to detect a 2-finger pinch.
    var activeTouches = {};
    var pinchStart = null;
    var suppressNextClick = false;
    function touchCount() {
      var n = 0;
      for (var k in activeTouches) if (activeTouches.hasOwnProperty(k)) n++;
      return n;
    }
    function touchList() {
      var out = [];
      for (var k in activeTouches) if (activeTouches.hasOwnProperty(k)) out.push(activeTouches[k]);
      return out;
    }
    function resetTouches() {
      activeTouches = {};
      pinchStart = null;
    }

    mapWrap.addEventListener(
      "pointerdown",
      function (e) {
        if (e.pointerType !== "touch") return;
        var t = e.target;
        // Don't hijack the resize handle or the zoom controls.
        if (t && t.closest && (t.closest(".lov-fp-resize") || t.closest(".lov-fp-zoom"))) return;
        // In edit mode booths handle their own drag — leave them alone.
        if (container.classList.contains("is-edit") && t && t.closest && t.closest(".lov-fp-booth")) return;
        activeTouches[e.pointerId] = { x: e.clientX, y: e.clientY, t: Date.now() };
        // Prune touches we never got an up/cancel for (>4s old). Without this,
        // a missed pointerup leaves a phantom finger and the next single-touch
        // pan is misread as a pinch — preventDefault kills native scrolling.
        var now = Date.now();
        for (var k in activeTouches) {
          if (activeTouches.hasOwnProperty(k) && k != e.pointerId && now - activeTouches[k].t > 4000) {
            delete activeTouches[k];
          }
        }
        if (touchCount() >= 2) {
          var pts = touchList();
          var dx = pts[0].x - pts[1].x,
            dy = pts[0].y - pts[1].y;
          var rect = mapWrap.getBoundingClientRect();
          pinchStart = {
            dist: Math.hypot(dx, dy) || 1,
            zoom: zoom,
            midX: (pts[0].x + pts[1].x) / 2 - rect.left,
            midY: (pts[0].y + pts[1].y) / 2 - rect.top,
          };
          suppressNextClick = true;
        } else {
          // Single touch: make sure no stale pinch state lingers.
          pinchStart = null;
        }
      },
      { passive: true },
    );

    mapWrap.addEventListener(
      "pointermove",
      function (e) {
        if (e.pointerType !== "touch") return;
        if (!activeTouches[e.pointerId]) return;
        activeTouches[e.pointerId].x = e.clientX;
        activeTouches[e.pointerId].y = e.clientY;
        activeTouches[e.pointerId].t = Date.now();
        // Only intercept when we truly have 2+ live fingers AND a pinch is armed.
        if (pinchStart && touchCount() >= 2) {
          e.preventDefault();
          var pts = touchList();
          var dx = pts[0].x - pts[1].x,
            dy = pts[0].y - pts[1].y;
          var dist = Math.hypot(dx, dy) || 1;
          var newZoom = Math.max(ZOOM_MIN, Math.min(ZOOM_MAX, pinchStart.zoom * (dist / pinchStart.dist)));
          if (Math.abs(newZoom - zoom) > 0.005) {
            zoom = newZoom;
            applyZoom(pinchStart.midX, pinchStart.midY);
          }
        }
      },
      { passive: false },
    );

    function endTouch(e) {
      if (e.pointerType !== "touch") return;
      delete activeTouches[e.pointerId];
      if (touchCount() < 2) pinchStart = null;
      if (touchCount() === 0) resetTouches();
    }
    // Listen on window so we never miss a release that happens outside mapWrap
    // (e.g. after native scroll/overscroll moves the touch off the element).
    // Without this, stale touches accumulate and break subsequent single-finger pans.
    window.addEventListener("pointerup", endTouch, true);
    window.addEventListener("pointercancel", endTouch, true);

    // Swallow the synthetic click that follows a pinch so booths don't open.
    mapWrap.addEventListener(
      "click",
      function (e) {
        if (suppressNextClick) {
          suppressNextClick = false;
          e.stopPropagation();
          e.preventDefault();
        }
      },
      true,
    );

    var panel = html("aside", { class: "lov-fp-panel" });
    var drawerBackdrop = html("div", { class: "lov-fp-drawer-backdrop", "aria-hidden": "true" });
    var panelClose = html(
      "button",
      { type: "button", class: "lov-fp-panel-close", "aria-label": "Close vendor details" },
      "×",
    );
    panel.appendChild(panelClose);
    panel.__closeBtn = panelClose;

    function closeDrawer() {
      container.classList.remove("is-drawer-open");
    }
    function openDrawer() {
      if (window.matchMedia && window.matchMedia("(max-width:899px)").matches) {
        container.classList.add("is-drawer-open");
      }
    }
    panelClose.addEventListener("click", closeDrawer);
    drawerBackdrop.addEventListener("click", closeDrawer);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeDrawer();
    });
    // Search box (above map)
    var searchBox = html("div", { class: "lov-fp-search", role: "search" });
    var searchInputWrap = html("div", { class: "lov-fp-search-input-wrap" });
    searchInputWrap.innerHTML =
      '<svg class="lov-fp-search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>';
    var searchInput = html("input", {
      type: "text",
      placeholder: "Search booths, vendors, categories…",
      "aria-label": "Search booths",
      autocomplete: "off",
    });
    var searchClear = html(
      "button",
      { type: "button", class: "lov-fp-search-clear", "aria-label": "Clear search" },
      "×",
    );
    var searchResults = html("div", { class: "lov-fp-search-results", role: "listbox" });
    searchInputWrap.appendChild(searchInput);
    searchInputWrap.appendChild(searchClear);
    searchBox.appendChild(searchInputWrap);
    searchBox.appendChild(searchResults);

    // Day toggle (Saturday / Sunday) — above the search box.
    var dayBox = html("div", { class: "lov-fp-days", role: "group", "aria-label": "Show day" });
    dayBox.appendChild(html("span", { class: "lov-fp-days-label" }, "Show day"));
    var dayGroup = html("div", { class: "lov-fp-days-group" });
    var dayBtns = {};
    ["sat", "sun"].forEach(function (d) {
      var btn = html(
        "button",
        { type: "button", class: "lov-fp-day", "data-day": d, "aria-pressed": "false" },
        d === "sat" ? "Saturday" : "Sunday",
      );
      dayBtns[d] = btn;
      dayGroup.appendChild(btn);
    });
    dayBox.appendChild(dayGroup);
    var dayNote = html("span", { class: "lov-fp-days-note" });
    dayBox.appendChild(dayNote);

    // Legend (under zoom)
    var legendBox = html("div", { class: "lov-fp-legend", role: "group", "aria-label": "Filter by category" });

    var leftCol = html("div", { class: "lov-fp-left" });
    leftCol.appendChild(dayBox);
    leftCol.appendChild(searchBox);
    leftCol.appendChild(mapWrap);
    leftCol.appendChild(zoomBox);
    leftCol.appendChild(legendBox);
    container.appendChild(leftCol);
    container.appendChild(panel);
    container.appendChild(drawerBackdrop);

    // Per-category color map — rebuilt after rebuild() based on actual vendors.
    var categoryColorMap = {};
    // Filter state.
    var initialDay = String(container.getAttribute("data-day") || "").toLowerCase().indexOf("sun") === 0 ? "sun" : "sat";
    try {
      var savedDay = window.localStorage.getItem("lov-fp:day");
      if (savedDay === "sat" || savedDay === "sun") initialDay = savedDay;
    } catch (e) {
      /* storage unavailable */
    }
    var filterState = {
      query: "",
      activeCats: Object.create(null),
      resultIdx: -1,
      results: [],
      day: initialDay,
    };

    function syncDayButtons() {
      ["sat", "sun"].forEach(function (d) {
        var on = filterState.day === d;
        dayBtns[d].classList.toggle("is-active", on);
        dayBtns[d].setAttribute("aria-pressed", on ? "true" : "false");
      });
    }
    function updateDayNote() {
      var total = 0;
      var open = 0;
      for (var i = 0; i < vendors.length; i++) {
        total++;
        if (vendorDays(vendors[i])[filterState.day]) open++;
      }
      dayNote.textContent = total ? open + " of " + total + " tables in use" : "";
      dayBox.style.display = total ? "" : "none";
    }
    function setDay(d, force) {
      if (d !== "sat" && d !== "sun") return;
      if (!force && filterState.day === d) return;
      filterState.day = d;
      currentShareDay = d;
      try {
        window.localStorage.setItem("lov-fp:day", d);
      } catch (e) {
        /* storage unavailable */
      }
      syncDayButtons();
      updateDayNote();
      applyFilters();
      // Drop a selection that isn't present on the newly chosen day.
      if (state.selected) {
        var sv = state.selected;
        if (sv && !vendorDays(sv)[filterState.day]) select(null);
      }
    }
    ["sat", "sun"].forEach(function (d) {
      dayBtns[d].addEventListener("click", function () {
        setDay(d);
      });
    });
    syncDayButtons();
    currentShareDay = filterState.day;

    var boothNodes = {};
    var state = { selected: null };
    var routePath;
    var routeGlow;
    var previewTimer = null;

    // Draw (or clear) the dotted route from the entrance to a vendor. When
    // `flash` is true the route pulses briefly so a tapped map pin reads as a
    // deliberate "preview this path" action.
    function drawRoute(v, flash) {
      if (!routePath) return;
      var d = v ? computePath(vendors, v) : null;
      if (d) {
        routePath.setAttribute("d", d);
        if (routeGlow) routeGlow.setAttribute("d", d);
      } else {
        routePath.removeAttribute("d");
        if (routeGlow) routeGlow.removeAttribute("d");
      }
      if (previewTimer) {
        clearTimeout(previewTimer);
        previewTimer = null;
      }
      routePath.classList.toggle("is-preview", !!(flash && d));
      if (routeGlow) routeGlow.classList.toggle("is-preview", !!(flash && d));
      if (flash && d) {
        previewTimer = setTimeout(function () {
          routePath.classList.remove("is-preview");
          if (routeGlow) routeGlow.classList.remove("is-preview");
          previewTimer = null;
        }, 2600);
      }
    }


    // --- Categories, search, and legend ---------------------------------
    function refreshCategoryMap() {
      categoryColorMap = {};
      var seen = [];
      for (var i = 0; i < vendors.length; i++) {
        var c = categoryKey(vendors[i]);
        if (!(c in categoryColorMap)) {
          categoryColorMap[c] = colorForCategory(c, seen.length);
          seen.push(c);
        }
      }
    }

    function buildLegend() {
      legendBox.innerHTML = "";
      var counts = {};
      var order = [];
      for (var i = 0; i < vendors.length; i++) {
        var c = categoryKey(vendors[i]);
        if (!(c in counts)) {
          counts[c] = 0;
          order.push(c);
        }
        counts[c]++;
      }
      if (order.length <= 1) return; // no point showing a 1-chip legend

      // "All" chip
      var allChip = html("button", { type: "button", class: "lov-fp-chip lov-fp-chip-all is-active" });
      allChip.appendChild(html("span", null, "All"));
      allChip.appendChild(html("span", { class: "lov-fp-chip-count" }, String(vendors.length)));
      allChip.addEventListener("click", function () {
        filterState.activeCats = Object.create(null);
        syncLegendActive();
        applyFilters();
      });
      legendBox.appendChild(allChip);

      order.forEach(function (cat) {
        var chip = html("button", { type: "button", class: "lov-fp-chip", "data-cat": cat });
        var sw = html("span", { class: "lov-fp-chip-swatch" });
        sw.style.background = categoryColorMap[cat] || "#94a3b8";
        chip.appendChild(sw);
        chip.appendChild(html("span", null, cat));
        chip.appendChild(html("span", { class: "lov-fp-chip-count" }, String(counts[cat])));
        chip.addEventListener("click", function () {
          if (filterState.activeCats[cat]) delete filterState.activeCats[cat];
          else filterState.activeCats[cat] = true;
          syncLegendActive();
          applyFilters();
        });
        legendBox.appendChild(chip);
      });
      syncLegendActive();
    }

    function syncLegendActive() {
      var anyActive = false;
      for (var k in filterState.activeCats) {
        anyActive = true;
        break;
      }
      var chips = legendBox.querySelectorAll(".lov-fp-chip");
      for (var i = 0; i < chips.length; i++) {
        var ch = chips[i];
        if (ch.classList.contains("lov-fp-chip-all")) {
          ch.classList.toggle("is-active", !anyActive);
        } else {
          var cat = ch.getAttribute("data-cat");
          ch.classList.toggle("is-active", !!filterState.activeCats[cat]);
        }
      }
    }

    function activeCategoryCount() {
      var n = 0;
      for (var k in filterState.activeCats) n++;
      return n;
    }

    function applyFilters() {
      var q = filterState.query.trim().toLowerCase();
      var hasCatFilter = activeCategoryCount() > 0;
      var matches = [];
      // Cells occupied by booths active on the selected day — a booth that is
      // off today but shares a cell with one that is on today gets hidden
      // entirely instead of ghosting underneath it.
      var takenCells = {};
      for (var tid in boothNodes) {
        var tnode = boothNodes[tid];
        if ((tnode.dataset.days || "sat sun").indexOf(filterState.day) === -1) continue;
        var tcells = (tnode.dataset.cells || "").split(" ");
        for (var ti = 0; ti < tcells.length; ti++) if (tcells[ti]) takenCells[tcells[ti]] = true;
      }
      for (var id in boothNodes) {
        var node = boothNodes[id];
        var hay = node.dataset.haystack || "";
        var cat = node.dataset.category || "";
        var dayOk = (node.dataset.days || "sat sun").indexOf(filterState.day) !== -1;
        var catOk = !hasCatFilter || !!filterState.activeCats[cat];
        var queryOk = !q || hay.indexOf(q) !== -1;
        var visible = dayOk && catOk && queryOk;
        var shadowed = false;
        if (!dayOk) {
          var cells = (node.dataset.cells || "").split(" ");
          for (var ci = 0; ci < cells.length; ci++) {
            if (cells[ci] && takenCells[cells[ci]]) {
              shadowed = true;
              break;
            }
          }
        }
        node.classList.toggle("is-day-shadowed", shadowed);
        node.classList.toggle("is-day-hidden", !dayOk);
        node.classList.toggle("is-cat-hidden", dayOk && !catOk);
        node.classList.toggle("is-dimmed", dayOk && catOk && !queryOk && !!q);
        node.classList.toggle("is-match", visible && !!q);
        if (visible && q) matches.push(id);
      }
      filterState.results = matches;
      renderSearchResults();
    }

    function renderSearchResults() {
      var q = filterState.query.trim();
      searchBox.classList.toggle("has-query", !!q);
      if (!q) {
        searchBox.classList.remove("is-open");
        searchResults.innerHTML = "";
        return;
      }
      searchBox.classList.add("is-open");
      searchResults.innerHTML = "";
      var ids = filterState.results.slice(0, 8);
      if (!ids.length) {
        var empty = html("div", { class: "lov-fp-search-empty" }, "No booths match \u201c" + q + "\u201d");
        searchResults.appendChild(empty);
        return;
      }
      ids.forEach(function (id, i) {
        var v = vendorById(id);
        if (!v) return;
        var row = html("div", {
          class: "lov-fp-search-result" + (i === filterState.resultIdx ? " is-active" : ""),
          role: "option",
        });
        row.appendChild(html("span", { class: "lov-fp-search-result-num" }, "#" + (v.booth || "")));
        row.appendChild(html("span", { class: "lov-fp-search-result-name" }, v.name || ""));
        if (v.category) row.appendChild(html("span", { class: "lov-fp-search-result-cat" }, v.category));
        row.addEventListener("mousedown", function (e) {
          e.preventDefault(); // keep input focus stable
          pickSearchResult(id);
        });
        searchResults.appendChild(row);
      });
    }

    function vendorById(id) {
      for (var i = 0; i < vendors.length; i++) if (vendors[i].id === id) return vendors[i];
      return null;
    }

    function pickSearchResult(id) {
      searchInput.value = "";
      filterState.query = "";
      filterState.resultIdx = -1;
      applyFilters();
      select(id);
      searchInput.blur();
    }

    var searchRaf = 0;
    searchInput.addEventListener("input", function () {
      filterState.query = searchInput.value || "";
      filterState.resultIdx = -1;
      if (searchRaf) cancelAnimationFrame(searchRaf);
      searchRaf = requestAnimationFrame(applyFilters);
    });
    searchInput.addEventListener("focus", function () {
      if (filterState.query) searchBox.classList.add("is-open");
    });
    searchInput.addEventListener("blur", function () {
      // Delay so result mousedown still fires.
      setTimeout(function () {
        searchBox.classList.remove("is-open");
      }, 120);
    });
    searchInput.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        searchInput.value = "";
        filterState.query = "";
        applyFilters();
        searchInput.blur();
      } else if (e.key === "Enter") {
        if (filterState.results.length) {
          var idx = filterState.resultIdx >= 0 ? filterState.resultIdx : 0;
          pickSearchResult(filterState.results[idx]);
        }
      } else if (e.key === "ArrowDown") {
        e.preventDefault();
        if (!filterState.results.length) return;
        filterState.resultIdx = (filterState.resultIdx + 1) % Math.min(filterState.results.length, 8);
        renderSearchResults();
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        if (!filterState.results.length) return;
        var max = Math.min(filterState.results.length, 8);
        filterState.resultIdx = (filterState.resultIdx - 1 + max) % max;
        renderSearchResults();
      }
    });
    searchClear.addEventListener("click", function () {
      searchInput.value = "";
      filterState.query = "";
      filterState.resultIdx = -1;
      applyFilters();
      searchInput.focus();
    });

    function rebuild() {
      svg.innerHTML = "";
      boothNodes = {};
      refreshCategoryMap();

      svg.appendChild(
        el("rect", {
          x: PAD - 16,
          y: PAD - 16,
          width: COLS * CELL + 32,
          height: ROWS * CELL + 32,
           rx: 20,
          fill: "#f8fafc",
          stroke: "#e2e8f0",
          "stroke-width": 2,
        }),
      );

      if (editable) {
        // grid lines
        for (var gc = 0; gc <= COLS; gc++) {
          svg.appendChild(
            el("line", {
              x1: PAD + gc * CELL,
              y1: PAD,
              x2: PAD + gc * CELL,
              y2: PAD + ROWS * CELL,
              stroke: "#eef2f7",
              "stroke-width": 1.5,
            }),
          );
        }
        for (var gr = 0; gr <= ROWS; gr++) {
          svg.appendChild(
            el("line", {
              x1: PAD,
              y1: PAD + gr * CELL,
              x2: PAD + COLS * CELL,
              y2: PAD + gr * CELL,
              stroke: "#eef2f7",
              "stroke-width": 1.5,
            }),
          );
        }
      }

      var ent = cellCenter(ENTRANCE.col, ENTRANCE.row);

      // Decorative double-door SVG — purely cosmetic, never intercepts
      // pointer events so it can't interfere with booth selection, the
      // entrance drag handle, or walker motion-paths.
      //
      // `orient` controls the swing axis:
      //   "h" — horizontal threshold, doors swing up/down (top/bottom walls)
      //   "v" — vertical threshold, doors swing left/right (side walls)
      function drawDoor(cx, cy, orient, label) {
        var g = el("g", {
          class: "lov-fp-doors",
          "aria-hidden": "true",
          "pointer-events": "none",
          style: "pointer-events:none",
        });
        var doorW = 36,
          doorH = 6,
          gap = 28;
        var thresholdW = doorW * 2 + gap;
        if (orient === "v") {
          // Vertical threshold (left/right walls)
          g.appendChild(
            el("rect", {
              x: cx - 3,
              y: cy - thresholdW / 2,
              width: 6,
              height: thresholdW,
              fill: "#cbd5e1",
              rx: 3,
            }),
          );
          g.appendChild(
            el("rect", {
              x: cx - doorH / 2,
              y: cy - (gap / 2 + doorW),
              width: doorH,
              height: doorW,
              fill: "#1e293b",
              rx: 1,
              transform: "rotate(-35 " + cx + " " + (cy - gap / 2) + ")",
            }),
          );
          g.appendChild(
            el("rect", {
              x: cx - doorH / 2,
              y: cy + gap / 2,
              width: doorH,
              height: doorW,
              fill: "#1e293b",
              rx: 1,
              transform: "rotate(35 " + cx + " " + (cy + gap / 2) + ")",
            }),
          );
          g.appendChild(el("circle", { cx: cx, cy: cy - gap / 2, r: 2.5, fill: "#0f172a" }));
          g.appendChild(el("circle", { cx: cx, cy: cy + gap / 2, r: 2.5, fill: "#0f172a" }));
        } else {
          // Horizontal threshold (top/bottom walls)
          g.appendChild(
            el("rect", {
              x: cx - thresholdW / 2,
              y: cy - 3,
              width: thresholdW,
              height: 6,
              fill: "#cbd5e1",
              rx: 3,
            }),
          );
          g.appendChild(
            el("rect", {
              x: cx - (gap / 2 + doorW),
              y: cy - doorH / 2,
              width: doorW,
              height: doorH,
              fill: "#1e293b",
              rx: 1,
              transform: "rotate(-35 " + (cx - gap / 2) + " " + cy + ")",
            }),
          );
          g.appendChild(
            el("rect", {
              x: cx + gap / 2,
              y: cy - doorH / 2,
              width: doorW,
              height: doorH,
              fill: "#1e293b",
              rx: 1,
              transform: "rotate(35 " + (cx + gap / 2) + " " + cy + ")",
            }),
          );
          g.appendChild(el("circle", { cx: cx - gap / 2, cy: cy, r: 2.5, fill: "#0f172a" }));
          g.appendChild(el("circle", { cx: cx + gap / 2, cy: cy, r: 2.5, fill: "#0f172a" }));
        }
        if (label) {
          var t = el("text", {
            x: cx,
            y: orient === "v" ? cy - thresholdW / 2 - 8 : cy - 12,
            "text-anchor": "middle",
            "font-size": 13,
            "font-weight": 600,
            fill: "#475569",
          });
          t.textContent = label;
          g.appendChild(t);
        }
        svg.appendChild(g);
      }

      // Entrance doors (always horizontal — entrance sits on top/bottom by default)
      drawDoor(ent.x, ent.y, "h");
      DOOR_POINTS = [{ col: ENTRANCE.col, row: ENTRANCE.row, label: "Main entrance" }];

      // Extra perimeter doors from opts.doors / data-doors attribute.
      // Each: { col, row, side?: "top"|"bottom"|"left"|"right", label? }
      // side is optional and only affects orientation; "left"/"right" → vertical.
      var extraDoors = opts.doors || [];
      for (var di = 0; di < extraDoors.length; di++) {
        var d = extraDoors[di];
        if (!d || !isFinite(+d.col) || !isFinite(+d.row)) continue;
        var dp = cellCenter(+d.col, +d.row);
        var orient = d.side === "left" || d.side === "right" ? "v" : "h";
        drawDoor(dp.x, dp.y, orient, d.label || "");
        // Walkers may also enter/exit through this door.
        if (d.walkers !== false) DOOR_POINTS.push({ col: +d.col, row: +d.row, label: d.label || "Door" });
      }


      // Walls — block walker paths (via WALL_CELLS) and render as slim bars.
      // Each wall: { col, row, length, orient: "h"|"v", openings?: [i,...], color?, thickness? }
      // Openings are 0-based cell indices along the wall that stay passable
      // (rendered as gaps so mascots can pass through).
      // Alternatively pass { cells: [[col,row], ...] } for freeform walls.
      WALL_CELLS = {};
      var wallsLayer = el("g", {
        class: "lov-fp-walls",
        "aria-hidden": "true",
        "pointer-events": "none",
        style: "pointer-events:none",
      });
      var wallsList = opts.walls || [];
      function paintWallCell(col, row, orient, color, thickness) {
        var t = Math.max(4, Math.min(CELL - 4, thickness || 12));
        var x = PAD + (col - 1) * CELL;
        var y = PAD + (row - 1) * CELL;
        var rect;
        if (orient === "v") {
          rect = el("rect", {
            x: x + CELL / 2 - t / 2,
            y: y,
            width: t,
            height: CELL,
            fill: color || "#334155",
            rx: 3,
          });
        } else {
          rect = el("rect", {
            x: x,
            y: y + CELL / 2 - t / 2,
            width: CELL,
            height: t,
            fill: color || "#334155",
            rx: 3,
          });
        }
        wallsLayer.appendChild(rect);
      }
      for (var wi = 0; wi < wallsList.length; wi++) {
        var wl = wallsList[wi];
        if (!wl) continue;
        // Freeform list of cells
        if (Array.isArray(wl.cells)) {
          for (var wc = 0; wc < wl.cells.length; wc++) {
            var pair = wl.cells[wc];
            if (!pair || pair.length < 2) continue;
            var wcCol = +pair[0],
              wcRow = +pair[1];
            if (!isFinite(wcCol) || !isFinite(wcRow)) continue;
            WALL_CELLS[wcCol + "," + wcRow] = true;
            paintWallCell(wcCol, wcRow, wl.orient === "v" ? "v" : "h", wl.color, wl.thickness);
          }
          continue;
        }
        var wCol = +wl.col,
          wRow = +wl.row;
        var wLen = Math.max(1, +wl.length || 1);
        var wOr = wl.orient === "v" ? "v" : "h";
        if (!isFinite(wCol) || !isFinite(wRow)) continue;
        var openings = {};
        if (Array.isArray(wl.openings)) {
          for (var oi = 0; oi < wl.openings.length; oi++) openings[+wl.openings[oi]] = true;
        }
        for (var seg = 0; seg < wLen; seg++) {
          if (openings[seg]) continue; // opening: passable, not drawn
          var cc = wOr === "v" ? wCol : wCol + seg;
          var rr = wOr === "v" ? wRow + seg : wRow;
          if (cc < 1 || cc > COLS || rr < 1 || rr > ROWS) continue;
          WALL_CELLS[cc + "," + rr] = true;
          paintWallCell(cc, rr, wOr, wl.color, wl.thickness);
        }
        if (wl.label) {
          var lp = cellCenter(wOr === "v" ? wCol : wCol + wLen / 2 - 0.5, wOr === "v" ? wRow + wLen / 2 - 0.5 : wRow);
          var wt = el("text", {
            x: lp.x,
            y: lp.y - 14,
            "text-anchor": "middle",
            "font-size": 12,
            "font-weight": 600,
            fill: "#475569",
          });
          wt.textContent = wl.label;
          wallsLayer.appendChild(wt);
        }
      }
      svg.appendChild(wallsLayer);

      svg.appendChild(el("circle", { class: "lov-fp-entrance", cx: ent.x, cy: ent.y, r: 18 }));
      var entLabel = el("text", { class: "lov-fp-entrance-label", x: ent.x, y: ent.y + 46, "text-anchor": "middle" });
      entLabel.textContent = "Entrance";
      svg.appendChild(entLabel);

      // (The four black dots that used to sit near the entrance now walk
      // looping routes alongside the mascots — see startWalkers().)

      // Roytato mascot near the entrance — clickable to show entrance info.
      // Image + size can be overridden via data-mascots={entranceMascotUrl,entranceMascotSize}.
      var entMascotUrl =
        (opts.mascots && opts.mascots.entranceMascotUrl) ||
        "https://cdn.shopify.com/s/files/1/0016/8892/8354/files/roytato-potato.png?v=1781241271";
      var entMascotSize = (opts.mascots && opts.mascots.entranceMascotSize) || 150;
      var mascot = el("image", {
        href: entMascotUrl,
        x: ent.x - entMascotSize * 0.6,
        y: ent.y - entMascotSize - 20,
        width: entMascotSize,
        height: entMascotSize,
        style: "cursor:pointer",
        role: "button",
        "aria-label": "Show entrance information and directions",
      });
      mascot.addEventListener("click", function () {
        showEntrance();
      });
      svg.appendChild(mascot);

      // Clicking the entrance circle/label also opens the entrance panel.
      // In edit mode the same hit-target also lets you drag the entrance to
      // a new grid position (snaps to half-cells; row can sit just outside
      // the grid on any side).
      var entranceHit = el("circle", {
        cx: ent.x,
        cy: ent.y,
        r: 40,
        fill: "transparent",
        style: editable ? "cursor:grab;touch-action:none" : "cursor:pointer",
        role: "button",
        "aria-label": editable ? "Drag to move entrance" : "Show entrance information",
      });
      svg.appendChild(entranceHit);

      if (!editable) {
        entranceHit.addEventListener("click", function () {
          showEntrance();
        });
      } else {
        var entDrag = { armed: false, dragging: false, start: null, startClient: null, origin: null, pid: null };
        var ENT_THRESHOLD = 5;
        entranceHit.addEventListener("pointerdown", function (e) {
          e.preventDefault();
          e.stopPropagation();
          entDrag.armed = true;
          entDrag.dragging = false;
          entDrag.start = svgPoint(e);
          entDrag.startClient = { x: e.clientX, y: e.clientY };
          entDrag.origin = { col: ENTRANCE.col, row: ENTRANCE.row };
          entDrag.pid = e.pointerId;
        });
        entranceHit.addEventListener("pointermove", function (e) {
          if (!entDrag.armed) return;
          if (!entDrag.dragging) {
            var dx0 = e.clientX - entDrag.startClient.x;
            var dy0 = e.clientY - entDrag.startClient.y;
            if (dx0 * dx0 + dy0 * dy0 < ENT_THRESHOLD * ENT_THRESHOLD) return;
            entDrag.dragging = true;
            entranceHit.style.cursor = "grabbing";
            try {
              entranceHit.setPointerCapture(e.pointerId);
            } catch (_) {}
          }
          var p = svgPoint(e);
          var dCol = (p.x - entDrag.start.x) / CELL;
          var dRow = (p.y - entDrag.start.y) / CELL;
          var snap = function (n) {
            return Math.round(n * 2) / 2;
          };
          var nc = clamp(snap(entDrag.origin.col + dCol), 0.5, COLS + 0.5);
          var nr = clamp(snap(entDrag.origin.row + dRow), 0.5, ROWS + 0.5);
          ENTRANCE.col = nc;
          ENTRANCE.row = nr;
          var c = cellCenter(nc, nr);
          entranceHit.setAttribute("cx", c.x);
          entranceHit.setAttribute("cy", c.y);
          var entCircle = svg.querySelector(".lov-fp-entrance");
          if (entCircle) {
            entCircle.setAttribute("cx", c.x);
            entCircle.setAttribute("cy", c.y);
          }
          var entLbl = svg.querySelector(".lov-fp-entrance-label");
          if (entLbl) {
            entLbl.setAttribute("x", c.x);
            entLbl.setAttribute("y", c.y + 46);
          }
          var entMascot = svg.querySelector("image[aria-label='Show entrance information and directions']");
          if (entMascot) {
            entMascot.setAttribute("x", c.x + 80);
            entMascot.setAttribute("y", c.y - 60);
          }
          if (statusEl)
            statusEl.textContent = "Entrance — col " + nc + ", row " + nr + " (drag to reposition, then Save)";
        });
        function endEntDrag(e) {
          if (!entDrag.armed) return;
          var wasDrag = entDrag.dragging;
          entDrag.armed = false;
          entDrag.dragging = false;
          entranceHit.style.cursor = "grab";
          try {
            if (entDrag.pid != null) entranceHit.releasePointerCapture(entDrag.pid);
          } catch (_) {}
          entDrag.pid = null;
          if (!wasDrag) {
            showEntrance();
          } else if (state.selected) {
            // Refresh route from new entrance to the currently selected booth.
            select(state.selected.id);
          }
        }
        entranceHit.addEventListener("pointerup", endEntDrag);
        entranceHit.addEventListener("pointercancel", endEntDrag);
      }

      vendors.forEach(function (v) {
        drawBooth(v);
      });

      // Route path appended LAST so the dotted line paints on top of booths.
      // A soft glow underlay makes the highlighted preview easy to follow.
      routeGlow = el("path", { class: "lov-fp-route-glow", "pointer-events": "none" });
      svg.appendChild(routeGlow);
      routePath = el("path", { class: "lov-fp-route", "pointer-events": "none" });
      var anim = el("animate", {
        attributeName: "stroke-dashoffset",
        from: "0",
        to: "-40",
        dur: "1.2s",
        repeatCount: "indefinite",
      });
      routePath.appendChild(anim);
      svg.appendChild(routePath);

      // Walkers layer (animated people walking from entrance to random tables)
      walkersLayer = el("g", { class: "lov-fp-walkers", "pointer-events": "none" });
      svg.appendChild(walkersLayer);
      // Spotlights layer (event-exclusive callouts on booths) — rendered above
      // walkers so the card + pulsing badge always read.
      renderSpotlights();
      // Re-apply current selection (e.g. after a rebuild) so the route survives.
      if (state.selected) drawRoute(state.selected, false);


      renderEmpty(panel);
      state.selected = null;
      startWalkers();
      // Expose a per-container API for adding custom walkers from host pages.
      container.__lovFpAddWalker = function (o) {
        return spawnWalker("custom", o || {});
      };
      // Refresh legend + day counts, reapply active search/category/day filters.
      try {
        buildLegend();
        updateDayNote();
        applyFilters();
      } catch (err2) {}
    }

    // Render event-exclusive spotlight callouts. Non-obstructive: small card
    // hovering above (or below) the booth with an image, title, short text,
    // and a "Navigate here" button that opens the booth's info panel + draws
    // the route from the entrance. A pulsing star also marks the booth so
    // attendees can spot the release at a glance while zoomed out.
    function renderSpotlights() {
      var list = (opts.spotlights || []).filter(Boolean);
      if (!list.length) return;
      var layer = el("g", { class: "lov-fp-spotlights" });
      var allBoothRects = [];
      for (var bi = 0; bi < vendors.length; bi++) allBoothRects.push(boothBox(vendors[bi]));
      var placedCards = [];
      function rectsOverlap(a, b) {
        return a.x < b.x + b.w && a.x + a.w > b.x && a.y < b.y + b.h && a.y + a.h > b.y;
      }
      function hasCollision(x, y, w, h) {
        var cand = { x: x, y: y, w: w, h: h };
        for (var i = 0; i < allBoothRects.length; i++) if (rectsOverlap(cand, allBoothRects[i])) return true;
        for (var j = 0; j < placedCards.length; j++) if (rectsOverlap(cand, placedCards[j])) return true;
        return false;
      }
      list.forEach(function (sp) {
        var key = String(sp.boothId != null ? sp.boothId : sp.booth != null ? sp.booth : sp.id || "");
        var v = null;
        for (var i = 0; i < vendors.length; i++) {
          var vv = vendors[i];
          if (String(vv.id) === key || String(vv.booth) === key) {
            v = vv;
            break;
          }
        }
        if (!v) return;
        var b = boothBox(v);

        // Pulsing star badge — sized large enough to be visible on mobile fit-view.
        var starR = 22;
        var sx = b.x + b.w - starR - 2;
        var sy = b.y + starR + 2;
        var starPath = "M0,-16 L4.7,-5 L16,-3.4 L7.7,4.3 L9.9,16 L0,10.1 L-9.9,16 L-7.7,4.3 L-16,-3.4 L-4.7,-5 Z";
        var star = el("g", { class: "lov-fp-spotlight-star", transform: "translate(" + sx + " " + sy + ")" });
        star.appendChild(el("circle", { r: starR, fill: "#fff", stroke: "#f59e0b", "stroke-width": 3 }));
        star.appendChild(el("path", { d: starPath, fill: "#f59e0b" }));
        layer.appendChild(star);

        // Native SVG callout card (foreignObject renders unreliably in iOS Safari).
        var cardW = 560;
        var cardH = 220;
        var pad = 14;
        var gap = 10;
        var margin = 6;

        // Find a placement that does not overlap any booth or prior spotlight
        // card. Try each side of the booth, sweeping along the perpendicular
        // axis outward from the booth center.
        function tryPlace(side) {
          var x, y, minX, maxX, minY, maxY, isHoriz;
          if (side === "above") {
            y = b.y - cardH - gap;
            if (y < margin) return null;
            minX = margin; maxX = W - cardW - margin;
            var cx0 = Math.max(minX, Math.min(maxX, b.cx - cardW / 2));
            isHoriz = true;
            for (var d = 0; d <= (maxX - minX); d += 16) {
              var xs = [cx0 + d, cx0 - d];
              for (var k = 0; k < xs.length; k++) {
                x = Math.max(minX, Math.min(maxX, xs[k]));
                if (!hasCollision(x, y, cardW, cardH)) return { x: x, y: y, side: side };
              }
            }
          } else if (side === "below") {
            y = b.y + b.h + gap;
            if (y + cardH > H - margin) return null;
            minX = margin; maxX = W - cardW - margin;
            var cx1 = Math.max(minX, Math.min(maxX, b.cx - cardW / 2));
            for (var d2 = 0; d2 <= (maxX - minX); d2 += 16) {
              var xs2 = [cx1 + d2, cx1 - d2];
              for (var k2 = 0; k2 < xs2.length; k2++) {
                x = Math.max(minX, Math.min(maxX, xs2[k2]));
                if (!hasCollision(x, y, cardW, cardH)) return { x: x, y: y, side: side };
              }
            }
          } else if (side === "right") {
            x = b.x + b.w + gap;
            if (x + cardW > W - margin) return null;
            minY = margin; maxY = H - cardH - margin;
            var cy0 = Math.max(minY, Math.min(maxY, b.cy - cardH / 2));
            for (var d3 = 0; d3 <= (maxY - minY); d3 += 16) {
              var ys = [cy0 + d3, cy0 - d3];
              for (var k3 = 0; k3 < ys.length; k3++) {
                y = Math.max(minY, Math.min(maxY, ys[k3]));
                if (!hasCollision(x, y, cardW, cardH)) return { x: x, y: y, side: side };
              }
            }
          } else if (side === "left") {
            x = b.x - cardW - gap;
            if (x < margin) return null;
            minY = margin; maxY = H - cardH - margin;
            var cy1 = Math.max(minY, Math.min(maxY, b.cy - cardH / 2));
            for (var d4 = 0; d4 <= (maxY - minY); d4 += 16) {
              var ys2 = [cy1 + d4, cy1 - d4];
              for (var k4 = 0; k4 < ys2.length; k4++) {
                y = Math.max(minY, Math.min(maxY, ys2[k4]));
                if (!hasCollision(x, y, cardW, cardH)) return { x: x, y: y, side: side };
              }
            }
          }
          return null;
        }
        var placement = tryPlace("above") || tryPlace("below") || tryPlace("right") || tryPlace("left");
        if (!placement) {
          // Fallback: place above without collision check, clamped to bounds.
          placement = {
            x: Math.max(margin, Math.min(W - cardW - margin, b.cx - cardW / 2)),
            y: Math.max(margin, b.y - cardH - gap),
            side: "above",
          };
        }
        var cx = placement.x;
        var cy = placement.y;
        var side = placement.side;

        var card = el("g", {
          class: "lov-fp-spotlight-callout",
          transform: "translate(" + cx + " " + cy + ")",
          style: "cursor:pointer",
        });
        // Shadow
        card.appendChild(
          el("rect", { x: 0, y: 3, width: cardW, height: cardH, rx: 12, ry: 12, fill: "rgba(15,23,42,0.18)" }),
        );
        // Body
        card.appendChild(
          el("rect", {
            x: 0,
            y: 0,
            width: cardW,
            height: cardH,
            rx: 12,
            ry: 12,
            fill: "#ffffff",
            stroke: "#f59e0b",
            "stroke-width": 2,
          }),
        );
        // Tail pointing at booth from the correct edge
        var tail = "", coverRect = null;
        if (side === "above") {
          var tx = Math.max(18, Math.min(cardW - 18, b.cx - cx));
          tail = "M" + (tx - 10) + "," + cardH + " L" + tx + "," + (cardH + 12) + " L" + (tx + 10) + "," + cardH + " Z";
          coverRect = { x: tx - 9, y: cardH - 1, width: 18, height: 2 };
        } else if (side === "below") {
          var tx2 = Math.max(18, Math.min(cardW - 18, b.cx - cx));
          tail = "M" + (tx2 - 10) + ",0 L" + tx2 + ",-12 L" + (tx2 + 10) + ",0 Z";
          coverRect = { x: tx2 - 9, y: -1, width: 18, height: 2 };
        } else if (side === "right") {
          var ty = Math.max(18, Math.min(cardH - 18, b.cy - cy));
          tail = "M0," + (ty - 10) + " L-12," + ty + " L0," + (ty + 10) + " Z";
          coverRect = { x: -1, y: ty - 9, width: 2, height: 18 };
        } else if (side === "left") {
          var ty2 = Math.max(18, Math.min(cardH - 18, b.cy - cy));
          tail = "M" + cardW + "," + (ty2 - 10) + " L" + (cardW + 12) + "," + ty2 + " L" + cardW + "," + (ty2 + 10) + " Z";
          coverRect = { x: cardW - 1, y: ty2 - 9, width: 2, height: 18 };
        }
        card.appendChild(el("path", { d: tail, fill: "#ffffff", stroke: "#f59e0b", "stroke-width": 2 }));
        if (coverRect) card.appendChild(el("rect", Object.assign({ fill: "#ffffff" }, coverRect)));
        placedCards.push({ x: cx, y: cy, w: cardW, h: cardH });

        var textX = pad;
        if (sp.image) {
          // Image fits inside the card as a square, scaling with cardH.
          var thumbSize = cardH - pad * 2;
          var clipId = "lov-fp-spot-clip-" + Math.random().toString(36).slice(2, 8);
          var defs = el("defs");
          var clip = el("clipPath", { id: clipId });
          clip.appendChild(el("rect", { x: pad, y: pad, width: thumbSize, height: thumbSize, rx: 8, ry: 8 }));
          defs.appendChild(clip);
          card.appendChild(defs);
          var image = el("image", {
            x: pad,
            y: pad,
            width: thumbSize,
            height: thumbSize,
            "clip-path": "url(#" + clipId + ")",
            preserveAspectRatio: "xMidYMid slice",
          });
          image.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", sp.image);
          image.setAttribute("href", sp.image);
          card.appendChild(image);
          card.appendChild(
            el("rect", {
              x: pad,
              y: pad,
              width: thumbSize,
              height: thumbSize,
              rx: 8,
              ry: 8,
              fill: "none",
              stroke: "#fde68a",
            }),
          );
          textX = pad + thumbSize + pad;
        }

        // Available text width (chars roughly = width / (fontSize*0.55))
        var textW = cardW - textX - pad;
        var eyebrowFS = 20;
        var titleFS = 40;
        var subFS = 36;
        var eyebrow = el("text", {
          x: textX,
          y: pad + eyebrowFS,
          fill: "#b45309",
          "font-size": eyebrowFS,
          "font-weight": 700,
          "letter-spacing": 1.4,
          "font-family": "ui-sans-serif,system-ui,sans-serif",
        });
        eyebrow.textContent = truncate((sp.eyebrow || "Event exclusive").toUpperCase(), Math.floor(textW / (eyebrowFS * 0.6)));
        card.appendChild(eyebrow);
        var title = el("text", {
          x: textX,
          y: pad + eyebrowFS + 10 + titleFS,
          fill: "#0f172a",
          "font-size": titleFS,
          "font-weight": 700,
          "font-family": "ui-sans-serif,system-ui,sans-serif",
        });
        title.textContent = truncate(sp.title || v.name, Math.floor(textW / (titleFS * 0.55)));
        card.appendChild(title);
        var subtitle = el("text", {
          x: textX,
          y: pad + eyebrowFS + 10 + titleFS + 12 + subFS,
          fill: "#475569",
          "font-size": subFS,
          "font-family": "ui-sans-serif,system-ui,sans-serif",
        });
        subtitle.textContent = truncate(sp.text || sp.cta || "Tap to navigate", Math.floor(textW / (subFS * 0.55)));
        card.appendChild(subtitle);

        card.addEventListener("click", function (e) {
          e.stopPropagation();
          select(v.id);
        });
        star.addEventListener("click", function (e) {
          e.stopPropagation();
          select(v.id);
        });
        star.style.cursor = "pointer";
        layer.appendChild(card);
      });
      svg.appendChild(layer);
    }

    function truncate(s, n) {
      s = String(s == null ? "" : s);
      return s.length > n ? s.slice(0, n - 1) + "\u2026" : s;
    }

    var walkersLayer;
    var walkerTimer;
    var WALKER_COLORS = ["#f59e0b", "#ef4444", "#8b5cf6", "#06b6d4", "#ec4899", "#22c55e"];

    // Mascot / dot customization. Override via data-mascots='{"mascotUrl":"...","mascotSize":80,"dotUrl":"...","dotSize":28,"dotColor":"#000","entranceMascotUrl":"...","entranceMascotSize":100}'
    var DEFAULT_MASCOT_URL = "https://cdn.shopify.com/s/files/1/0016/8892/8354/files/roytato-potato.png";
    var mascotCfg = opts.mascots || {};
    var MASCOT_URL = mascotCfg.mascotUrl || DEFAULT_MASCOT_URL;
    var MASCOT_SIZE = mascotCfg.mascotSize || 120;
    var DOT_URL = mascotCfg.dotUrl || null; // if provided, dots render as an image instead of a circle
    var DOT_SIZE = mascotCfg.dotSize || 36;
    var DOT_COLOR = mascotCfg.dotColor || "#000000";

    // Parse "M x y L x y ..." into a point array.
    function parsePathPoints(d) {
      var tokens = d.split(/\s+/).filter(Boolean);
      var pts = [];
      for (var i = 0; i < tokens.length; i++) {
        if (tokens[i] === "M" || tokens[i] === "L") {
          pts.push([+tokens[i + 1], +tokens[i + 2]]);
          i += 2;
        }
      }
      return pts;
    }

    function pointsToPath(pts) {
      return pts
        .map(function (p, i) {
          return (i === 0 ? "M" : "L") + " " + p[0] + " " + p[1];
        })
        .join(" ");
    }

    function reversePathString(d) {
      var pts = parsePathPoints(d);
      pts.reverse();
      return pointsToPath(pts);
    }

    // Return a motion path relative to the entrance so the walker <g> can keep
    // a base transform at the entrance. This prevents the element from snapping
    // back to (0,0) when old animateMotion nodes are removed between cycles.
    function computeWalkerPath(vendors, selected, origin) {
      var absPath = computePath(vendors, selected, origin);
      if (!absPath) return null;
      var pts = parsePathPoints(absPath);
      var ox = pts[0][0],
        oy = pts[0][1];
      for (var i = 0; i < pts.length; i++) {
        pts[i][0] -= ox;
        pts[i][1] -= oy;
      }
      return pointsToPath(pts);
    }

    // Pick a door for a walker to emerge from (main entrance + any data-doors).
    function pickDoor() {
      var list = DOOR_POINTS.length ? DOOR_POINTS : [{ col: ENTRANCE.col, row: ENTRANCE.row }];
      return list[Math.floor(Math.random() * list.length)];
    }

    function spawnWalker(kind, opts) {
      if (!walkersLayer || !vendors.length) return null;
      opts = opts || {};
      var isDot = kind === "dot";
      var isCustom = kind === "custom";
      var g = el("g", {
        class:
          "lov-fp-walker-group" +
          (isDot ? " lov-fp-dot-walker" : isCustom ? " lov-fp-custom-walker" : " lov-fp-mascot-walker"),
        "aria-label": isDot ? "Dot walker" : isCustom ? opts.label || "Custom walker" : "Mascot walker",
      });
      // Each walker belongs to one door; it enters and leaves through it.
      var homeDoor =
        opts.door && isFinite(+opts.door.col) && isFinite(+opts.door.row)
          ? { col: +opts.door.col, row: +opts.door.row }
          : pickDoor();
      // Anchor the walker at its door so it never flashes at SVG origin (0,0).
      var entPt = cellCenter(homeDoor.col, homeDoor.row);
      g.setAttribute("transform", "translate(" + entPt.x + " " + entPt.y + ")");

      // Render the walker away from its door edge: with a door on the bottom
      // the sprite sits ABOVE its anchor (feet at y=0); with a door on the top
      // it hangs BELOW the anchor so it never covers the booths above it.
      var entAtTop = homeDoor.row < ROWS / 2;

      var visual;

      function makeDotVisual(vendor) {
        var url = (vendor && (vendor.dotUrl || vendor.dot_url)) || DOT_URL;
        var color = (vendor && (vendor.dotColor || vendor.dot_color)) || DOT_COLOR;
        var vsize = (vendor && (vendor.dotSize || vendor.dot_size)) || DOT_SIZE;
        var node;
        if (url) {
          node = el("image", {
            class: "lov-fp-dot-walker-img",
            href: url,
            x: -vsize / 2,
            y: entAtTop ? 0 : -vsize,

            width: vsize,
            height: vsize,
          });
        } else {
          var dotR = vsize / 2;
          node = el("circle", {
            class: "lov-fp-dot-walker-dot",
            r: dotR,
            cx: 0,
            cy: entAtTop ? dotR : -dotR,
            fill: color,
            stroke: "none",
          });
        }
        node.appendChild(
          el("animateTransform", {
            attributeName: "transform",
            type: "translate",
            values: "0 0; 0 -3; 0 0",
            dur: "0.35s",
            repeatCount: "indefinite",
          }),
        );
        return node;
      }
      if (isDot) {
        visual = makeDotVisual(null);
      } else {
        var size = isCustom ? opts.size || MASCOT_SIZE : MASCOT_SIZE;
        visual = el("image", {
          href: isCustom ? opts.imageUrl || MASCOT_URL : MASCOT_URL,
          x: -size / 2,
          y: entAtTop ? 0 : -size, // feet at anchor, body away from entrance edge
          width: size,
          height: size,
        });
        visual.appendChild(
          el("animateTransform", {
            attributeName: "transform",
            type: "translate",
            values: "0 0; 0 -5; 0 0",
            dur: "0.5s",
            repeatCount: "indefinite",
          }),
        );
      }
      g.appendChild(visual);

      // Thought bubble (mascots + custom walkers only; dots are too small).
      var bubble = null,
        bubbleText = null,
        bubbleRect = null,
        bubbleTail = null;
      if (!isDot) {
        var bsize = isCustom ? opts.size || MASCOT_SIZE : MASCOT_SIZE;
        // Sit clear of the mascot's head, on the side away from the entrance.
        var by = entAtTop ? bsize + 34 : -bsize - 34;
        bubble = el("g", { class: "lov-fp-thought", transform: "translate(0 " + by + ")" });
        bubbleRect = el("rect", {
          class: "lov-fp-thought-bubble",
          x: -60,
          y: -18,
          width: 120,
          height: 36,
          rx: 18,
          ry: 18,
        });
        bubbleTail = el("path", {
          class: "lov-fp-thought-tail",
          d: entAtTop ? "M-6 -16 L0 -28 L6 -16 Z" : "M-6 16 L0 28 L6 16 Z",
        });

        bubbleText = el("text", { class: "lov-fp-thought-text", x: 0, y: 1 });
        bubble.appendChild(bubbleRect);
        bubble.appendChild(bubbleTail);
        bubble.appendChild(bubbleText);
        g.appendChild(bubble);
      }

      var DEFAULT_THOUGHTS = [
        "Where to next?",
        "Looks like my iso!",
        "Ooh, stitch!",
        "Hi there!",
        "Let's check it out",
        "So many pins!",
      ];
      var ARRIVAL_THOUGHTS = [
        "Made it!",
        "Here we are!",
        "Ooh, nice pins!",
        "Let's see what they've got",
        "Did I bring enough pins!",
        "Did I just see Haaland?",
        "Whats Kraken!",
      ];
      var HIGHLIGHT_THOUGHTS = [
        "Ooh, check that one out!",
        "Good pick!",
        "Heading there now!",
        "That pin looks great",
        "Let's open up some blind boxes!",
      ];
      function pickThought(vendor) {
        if (isCustom && Array.isArray(opts.thoughts) && opts.thoughts.length) {
          return opts.thoughts[Math.floor(Math.random() * opts.thoughts.length)];
        }
        if (vendor && Math.random() < 0.5) {
          return "Off to " + (vendor.name || "booth " + (vendor.booth || vendor.id)) + "!";
        }
        return DEFAULT_THOUGHTS[Math.floor(Math.random() * DEFAULT_THOUGHTS.length)];
      }
      function pickArrival(vendor) {
        if (vendor && Math.random() < 0.55) {
          return vendor.name ? vendor.name + "!" : "Booth " + (vendor.booth || vendor.id) + "!";
        }
        return ARRIVAL_THOUGHTS[Math.floor(Math.random() * ARRIVAL_THOUGHTS.length)];
      }
      function pickHighlight(vendor) {
        if (vendor && Math.random() < 0.6) {
          return "Ooh, " + (vendor.name || "booth " + (vendor.booth || vendor.id)) + "!";
        }
        return HIGHLIGHT_THOUGHTS[Math.floor(Math.random() * HIGHLIGHT_THOUGHTS.length)];
      }
      function fitBubble(txt) {
        if (!bubble) return;
        bubbleText.textContent = txt;
        var w = Math.max(80, Math.min(240, txt.length * 8.4 + 24));
        bubbleRect.setAttribute("x", String(-w / 2));
        bubbleRect.setAttribute("width", String(w));
      }
      function showBubble(txt, ms) {
        if (!bubble) return;
        fitBubble(txt);
        bubble.classList.add("is-visible");
        clearTimeout(bubble.__hideT);
        bubble.__hideT = setTimeout(function () {
          bubble.classList.remove("is-visible");
        }, ms || 2600);
      }
      // Expose so external events (e.g. table info panel opening) can trigger bubbles.
      g.__showBubble = showBubble;
      g.__pickHighlight = pickHighlight;
      g.__isDot = isDot;

      walkersLayer.appendChild(g);

      var stopped = false;
      g.__stopWalker = function () {
        stopped = true;
        if (bubble) clearTimeout(bubble.__hideT);
      };

      function findTarget() {
        var key = opts.id != null ? opts.id : opts.boothId;
        if (key != null) {
          var keyStr = String(key);
          for (var i = 0; i < vendors.length; i++) {
            if (String(vendors[i].id) === keyStr) return vendors[i];
            if (vendors[i].booth != null && String(vendors[i].booth) === keyStr) return vendors[i];
          }
          console.warn("[floor-plan] addWalker: no vendor found for id", keyStr);
        }
        // Only walk to tables that are in use on the currently selected day.
        var openToday = [];
        for (var oi = 0; oi < vendors.length; oi++) {
          if (vendorDays(vendors[oi])[filterState.day]) openToday.push(vendors[oi]);
        }
        if (!openToday.length) openToday = vendors;
        return openToday[Math.floor(Math.random() * openToday.length)];
      }

      function walkCycle() {
        if (stopped || !g.parentNode || !vendors.length) return;
        var v = findTarget();
        // For dots, swap the visual to match this vendor's dotUrl/dotColor/dotSize.
        if (isDot) {
          var next = makeDotVisual(v);
          if (visual && visual.parentNode === g) g.removeChild(visual);
          visual = next;
          g.appendChild(visual);
        }
        // Say something about the trip roughly half the time.
        if (bubble && Math.random() < 0.7) {
          showBubble(pickThought(v), 3800);
        }
        var oneWay = computeWalkerPath(vendors, v, homeDoor);
        if (!oneWay) {
          setTimeout(walkCycle, 1000);
          return;
        }
        var back = reversePathString(oneWay);
        // Half-trip duration; dots are smaller/faster than mascots.
        // holdAtTable affects how long a mascot is at a table.
        var halfDur = isDot ? (2.5 + Math.random() * 1.5) * 1.25 : (4 + Math.random() * 2) * 1.25;
        var holdAtTable = isCustom && opts.holdAtTable != null ? opts.holdAtTable : 4.5;
        var holdAtEntrance = isDot ? 0.8 : 1.2;

        // Clear previous motions
        var prev = g.querySelectorAll("animateMotion");
        for (var p = 0; p < prev.length; p++) g.removeChild(prev[p]);

        var motionOut = el("animateMotion", {
          dur: halfDur + "s",
          begin: "indefinite",
          repeatCount: "1",
          rotate: "0",
          fill: "freeze",
          path: oneWay,
        });
        var motionBack = el("animateMotion", {
          dur: halfDur + "s",
          begin: "indefinite",
          repeatCount: "1",
          rotate: "0",
          fill: "freeze",
          path: back,
        });
        g.appendChild(motionOut);
        g.appendChild(motionBack);
        // Show an "arrived at booth" bubble when the outbound trip ends.
        if (bubble) {
          var arrivedVendor = v;
          var onArrive = function () {
            motionOut.removeEventListener("endEvent", onArrive);
            if (stopped) return;
            showBubble(pickArrival(arrivedVendor), Math.max(1200, holdAtTable * 1000 - 200));
          };
          motionOut.addEventListener("endEvent", onArrive);
        }
        try {
          motionOut.beginElement();
        } catch (e) {}
        // Schedule the return trip relative to "now" instead of an absolute
        // document timestamp — otherwise the second cycle's begin time is in
        // the past and the walker never returns to the entrance.
        try {
          motionBack.beginElementAt(halfDur + holdAtTable);
        } catch (e2) {}

        if (isCustom && opts.loop === false) return;
        // Total: out + hold@table + back + hold@entrance
        var total = halfDur * 2 + holdAtTable + holdAtEntrance;
        setTimeout(walkCycle, total * 1000);
      }
      walkCycle();
      return g;
    }

    function startWalkers() {
      if (walkerTimer) clearInterval(walkerTimer);
      // 3 mascot walkers + 4 black-dot walkers, all looping.
      var MASCOTS = 5;
      var DOTS = 4;
      for (var i = 0; i < MASCOTS; i++) {
        setTimeout(function () {
          spawnWalker("mascot");
        }, i * 2500);
      }
      for (var j = 0; j < DOTS; j++) {
        setTimeout(
          function () {
            spawnWalker("dot");
          },
          600 + j * 700,
        );
      }
      // Top-up in case rebuild() clears the layer.
      walkerTimer = setInterval(function () {
        if (!walkersLayer) return;
        var have = walkersLayer.childNodes.length;
        var want = MASCOTS + DOTS;
        while (have < want) {
          // Refill with dots first (cheaper); mascots replenish on next tick.
          spawnWalker(have < DOTS ? "dot" : "mascot");
          have++;
        }
      }, 4000);
    }

    function drawBooth(v) {
      var b = boothBox(v);
      var cat = categoryKey(v);
      var catColor = categoryColorMap[cat] || "#94a3b8";
      var g = el("g", {
        class: "lov-fp-booth" + v.booth + " lov-fp-booth ",
        tabindex: "0",
        role: "button",
        "aria-label": "Booth " + v.booth + ": " + v.name,
      });
      g.dataset.id = v.id;
      g.dataset.category = cat;
      var vd = vendorDays(v);
      g.dataset.days = (vd.sat ? "sat " : "") + (vd.sun ? "sun" : "");
      var bc0 = +v.col || 1,
        br0 = +v.row || 1,
        bcw = Math.max(1, +v.w || 1),
        bch = Math.max(1, +v.h || 1),
        bcells = [];
      for (var bcx = 0; bcx < bcw; bcx++)
        for (var bcy = 0; bcy < bch; bcy++) bcells.push(bc0 + bcx + "," + (br0 + bcy));
      g.dataset.cells = bcells.join(" ");
      g.dataset.haystack = (
        (v.booth || "") +
        " " +
        (v.name || "") +
        " " +
        (v.category || "") +
        " " +
        (v.description || "")
      ).toLowerCase();
      var rect = el("rect", {
        class: "lov-fp-booth-bg",
        x: b.x,
        y: b.y,
        width: b.w,
        height: b.h,
        rx: 16,
        fill: tintColor(catColor, 0.85),
        stroke: catColor,
        "stroke-width": 3,
      });
      var label = el("text", {
        x: b.cx,
        y: b.cy - 10,
        "text-anchor": "middle",
        "font-size": 36,
        "font-weight": 700,
        "letter-spacing": "0.01em",
        fill: "#0f172a",
      });
      label.textContent = v.booth;
      var maxChars = Math.max(8, (v.w || 1) * 9);
      var sub = el("text", {
        x: b.cx,
        y: b.cy + 28,
        "text-anchor": "middle",
        "font-size": 22,
        "font-weight": 500,
        fill: "#475569",
      });
      sub.textContent = v.name.length > maxChars ? v.name.slice(0, maxChars - 1) + "…" : v.name;
      g.appendChild(rect);
      // Subtle top sheen so booths read as raised surfaces, not flat fills.
      g.appendChild(
        el("rect", {
          class: "lov-fp-booth-sheen",
          x: b.x + 3,
          y: b.y + 3,
          width: b.w - 6,
          height: Math.max(10, b.h * 0.32),
          rx: 13,
          fill: "#ffffff",
          opacity: 0.35,
          "pointer-events": "none",
        }),
      );
      g.appendChild(label);
      g.appendChild(sub);

      if (editable) {
        var handle = el("rect", {
          class: "lov-fp-resize",
          x: b.x + b.w - 24,
          y: b.y + b.h - 24,
          width: 20,
          height: 20,
          rx: 4,
        });
        g.appendChild(handle);
        attachEditHandlers(g, v, rect, handle);
      } else {
        g.addEventListener("click", function () {
          select(v.id);
        });
        g.addEventListener("keydown", function (e) {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            select(v.id);
          }
        });
        // Hover preview: mouse users get a peek at the vendor without
        // committing to a selection. Touch devices skip this and use tap.
        g.addEventListener("pointerenter", function (e) {
          if (e.pointerType === "touch") return;
          if (state.selected && state.selected.id === v.id) return;
          panel.classList.add("is-preview");
          renderVendor(panel, v);
        });
        g.addEventListener("pointerleave", function (e) {
          if (e.pointerType === "touch") return;
          panel.classList.remove("is-preview");
          if (state.selected) renderVendor(panel, state.selected);
          else renderEntrance(panel);
        });
      }
      svg.appendChild(g);
      boothNodes[v.id] = g;
    }

    function svgPoint(e) {
      var pt = svg.createSVGPoint();
      pt.x = e.clientX;
      pt.y = e.clientY;
      var ctm = svg.getScreenCTM();
      if (!ctm) return { x: 0, y: 0 };
      var p = pt.matrixTransform(ctm.inverse());
      return { x: p.x, y: p.y };
    }
    function pointToCell(p) {
      var col = Math.floor((p.x - PAD) / CELL) + 1;
      var row = Math.floor((p.y - PAD) / CELL) + 1;
      return { col: col, row: row };
    }
    function overlaps(v, col, row, w, h) {
      for (var i = 0; i < vendors.length; i++) {
        var o = vendors[i];
        if (o.id === v.id) continue;
        var ow = Math.max(1, o.w || 1),
          oh = Math.max(1, o.h || 1);
        if (col < o.col + ow && col + w > o.col && row < o.row + oh && row + h > o.row) return true;
      }
      return false;
    }
    function clamp(n, min, max) {
      return Math.max(min, Math.min(max, n));
    }

    function attachEditHandlers(g, v, rect, handle) {
      // Two-phase pointer model: pressing a booth "arms" a potential drag but
      // does not move anything until the pointer travels past DRAG_THRESHOLD
      // pixels. A pointerup before that threshold is treated as a click and
      // simply selects the booth — so it's easy to pick one without
      // accidentally dragging every booth you hover over.
      var DRAG_THRESHOLD = 5;
      var armed = false,
        dragging = false,
        mode = null,
        startPt = null,
        startClient = null,
        origin = null,
        pointerId = null;

      function onDown(e, m) {
        e.preventDefault();
        e.stopPropagation();
        armed = true;
        dragging = false;
        mode = m;
        startPt = svgPoint(e);
        startClient = { x: e.clientX, y: e.clientY };
        origin = { col: v.col, row: v.row, w: v.w || 1, h: v.h || 1 };
        pointerId = e.pointerId;
        // Resize handle always drags immediately — there's nothing to "click".
        if (m === "resize") beginDrag(e);
      }
      function beginDrag(e) {
        dragging = true;
        g.classList.add("is-dragging");
        try {
          g.setPointerCapture(e.pointerId);
        } catch (_) {}
      }
      function onMove(e) {
        if (!armed) return;
        if (!dragging) {
          var dx = e.clientX - startClient.x;
          var dy = e.clientY - startClient.y;
          if (dx * dx + dy * dy < DRAG_THRESHOLD * DRAG_THRESHOLD) return;
          beginDrag(e);
        }
        var p = svgPoint(e);
        var dCol = Math.round((p.x - startPt.x) / CELL);
        var dRow = Math.round((p.y - startPt.y) / CELL);
        if (mode === "move") {
          var nc = clamp(origin.col + dCol, 1, COLS - origin.w + 1);
          var nr = clamp(origin.row + dRow, 1, ROWS - origin.h + 1);
          if (!overlaps(v, nc, nr, origin.w, origin.h)) {
            v.col = nc;
            v.row = nr;
          }
        } else {
          var nw = clamp(origin.w + dCol, 1, COLS - v.col + 1);
          var nh = clamp(origin.h + dRow, 1, ROWS - v.row + 1);
          if (!overlaps(v, v.col, v.row, nw, nh)) {
            v.w = nw;
            v.h = nh;
          }
        }
        updateBoothGeom();
        if (statusEl)
          statusEl.textContent = v.booth + " — col " + v.col + ", row " + v.row + ", " + (v.w || 1) + "x" + (v.h || 1);
      }
      function onUp(e) {
        if (!armed) return;
        var wasDragging = dragging;
        armed = false;
        dragging = false;
        mode = null;
        g.classList.remove("is-dragging");
        try {
          if (pointerId != null) g.releasePointerCapture(pointerId);
        } catch (_) {}
        pointerId = null;
        // Click (no drag) → select this booth so Remove and the side panel
        // can act on it.
        if (!wasDragging) {
          select(v.id);
          // Refresh selected highlight + path immediately.
          if (statusEl) statusEl.textContent = "Selected " + (v.booth || v.id) + ".";
        }
      }
      function updateBoothGeom() {
        var b = boothBox(v);
        rect.setAttribute("x", b.x);
        rect.setAttribute("y", b.y);
        rect.setAttribute("width", b.w);
        rect.setAttribute("height", b.h);
        var texts = g.querySelectorAll("text");
        if (texts[0]) {
          texts[0].setAttribute("x", b.cx);
          texts[0].setAttribute("y", b.cy - 4);
        }
        if (texts[1]) {
          texts[1].setAttribute("x", b.cx);
          texts[1].setAttribute("y", b.cy + 14);
        }
        handle.setAttribute("x", b.x + b.w - 14);
        handle.setAttribute("y", b.y + b.h - 14);
      }

      rect.addEventListener("pointerdown", function (e) {
        onDown(e, "move");
      });
      handle.addEventListener("pointerdown", function (e) {
        onDown(e, "resize");
      });
      g.addEventListener("pointermove", onMove);
      g.addEventListener("pointerup", onUp);
      g.addEventListener("pointercancel", onUp);
    }

    function select(id) {
      var v = null;
      for (var i = 0; i < vendors.length; i++)
        if (vendors[i].id === id) {
          v = vendors[i];
          break;
        }
      state.selected = v;
      for (var bid in boothNodes) boothNodes[bid].classList.toggle("is-selected", bid === id);
      drawRoute(v, false);

      if (v) {
        renderVendor(panel, v);
        openDrawer();
      } else renderEmpty(panel);
      // When a booth's info panel opens, have 1-2 nearby mascots react with a bubble.
      if (v && walkersLayer) {
        try {
          var kids = walkersLayer.childNodes;
          var mascots = [];
          for (var wi = 0; wi < kids.length; wi++) {
            var w = kids[wi];
            if (w && w.__showBubble && !w.__isDot) mascots.push(w);
          }
          // Shuffle-lite: pick up to 2 random mascots.
          for (var mi = mascots.length - 1; mi > 0; mi--) {
            var swi = Math.floor(Math.random() * (mi + 1));
            var tmp = mascots[mi];
            mascots[mi] = mascots[swi];
            mascots[swi] = tmp;
          }
          var count = Math.min(mascots.length, 2);
          for (var ci = 0; ci < count; ci++) {
            (function (walker, delay) {
              setTimeout(function () {
                try {
                  walker.__showBubble(walker.__pickHighlight(v), 3600);
                } catch (_) {}
              }, delay);
            })(mascots[ci], ci * 350);
          }
        } catch (_) {}
      }
      // Dispatch a scoped event on this container so multiple floor plans on the
      // same page stay isolated. Hosts (e.g. the Shopify Liquid pill) should
      // listen on their own <div data-floor-plan> element, not on document.
      try {
        node.dispatchEvent(
          new CustomEvent("lov-fp:select", {
            detail: {
              booth: v ? v.booth || v.id : null,
              id: v ? v.id : null,
              name: v ? v.name : null,
              vendor: v || null,
            },
            bubbles: true,
          }),
        );
      } catch (_) {}
    }

    function showEntrance() {
      state.selected = null;
      for (var bid in boothNodes) boothNodes[bid].classList.remove("is-selected");
      drawRoute(null, false);
      renderEntrance(panel);
    }

    function showExport(list) {
      var overlay = html("div", { class: "lov-fp-export" });
      var card = html("div", { class: "lov-fp-export-card" });
      card.appendChild(html("h3", null, "Vendor layout JSON"));
      card.appendChild(
        html(
          "p",
          { style: "margin:0;color:#64748b;font-size:13px" },
          "Copy this and paste into your <div data-vendors='...'> on Shopify.",
        ),
      );
      var ta = html("textarea");
      ta.value = JSON.stringify(list, null, 2);
      card.appendChild(ta);
      var row = html("div", { class: "lov-fp-row" });
      var copy = html("button");
      copy.textContent = "Copy";
      copy.className = "";
      copy.style.cssText = "background:#2563eb;color:#fff;border:0;border-radius:6px;padding:8px 14px;cursor:pointer";
      var close = html("button");
      close.textContent = "Close";
      close.style.cssText =
        "background:#fff;color:#0f172a;border:1px solid #cbd5e1;border-radius:6px;padding:8px 14px;cursor:pointer";
      copy.addEventListener("click", function () {
        ta.select();
        try {
          navigator.clipboard.writeText(ta.value);
          copy.textContent = "Copied!";
          setTimeout(function () {
            copy.textContent = "Copy";
          }, 1500);
        } catch (_) {
          document.execCommand("copy");
        }
      });
      close.addEventListener("click", function () {
        document.body.removeChild(overlay);
      });
      overlay.addEventListener("click", function (e) {
        if (e.target === overlay) document.body.removeChild(overlay);
      });
      row.appendChild(copy);
      row.appendChild(close);
      card.appendChild(row);
      overlay.appendChild(card);
      document.body.appendChild(overlay);
      ta.focus();
      ta.select();
    }

    rebuild();

    // Deep-link: auto-select booth from ?booth=<id|number> or #booth=<id|number>
    // Reliable across: initial load, full refresh, browser back/forward, and iOS bfcache restore.
    function readBoothParam() {
      try {
        // 1. Query string on current URL
        var q = new URLSearchParams(window.location.search || "");
        var v = q.get("booth");
        if (v) return v;
        // 2. Hash variants: #booth=X or #?booth=X or just #X after a "booth" marker
        var h = (window.location.hash || "").replace(/^#/, "");
        if (!h) {
          // 3. Fallback: container-level data attr (set by Shopify Custom Liquid snippet
          //    when parent strips query params).
          var dl = container.getAttribute("data-deep-link") || container.getAttribute("data-booth");
          if (dl) return dl;
          return null;
        }
        if (h.indexOf("booth=") === 0) return decodeURIComponent(h.slice(6));
        try {
          var hq = new URLSearchParams(h.replace(/^\?/, ""));
          var hv = hq.get("booth");
          if (hv) return hv;
        } catch (_) {}
        return null;
      } catch (_) {
        return null;
      }
    }
    function findVendor(key) {
      if (key == null) return null;
      var k = String(key).trim().toLowerCase();
      if (!k) return null;
      for (var i = 0; i < vendors.length; i++) {
        var v = vendors[i];
        if (String(v.id).toLowerCase() === k || String(v.booth).toLowerCase() === k) return v;
      }
      return null;
    }
    function scrollBoothIntoView(node) {
      if (!node) return;
      try {
        // Scroll the map's own scroll container (overflow:auto) so we don't yank the page.
        if (mapWrap && (mapWrap.scrollWidth > mapWrap.clientWidth || mapWrap.scrollHeight > mapWrap.clientHeight)) {
          var nRect = node.getBoundingClientRect();
          var mRect = mapWrap.getBoundingClientRect();
          var dx = nRect.left + nRect.width / 2 - (mRect.left + mRect.width / 2);
          var dy = nRect.top + nRect.height / 2 - (mRect.top + mRect.height / 2);
          mapWrap.scrollBy({ left: dx, top: dy, behavior: "smooth" });
        }
        // Also scroll the page so the widget is in view on mobile.
        if (node.scrollIntoView) {
          node.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
        }
      } catch (_) {}
    }
    function readDayParam() {
      try {
        var q = new URLSearchParams(window.location.search || "");
        var d = String(q.get("day") || "").toLowerCase();
        if (d === "sat" || d === "sun") return d;
        var h = (window.location.hash || "").replace(/^#/, "");
        if (h) {
          var hq = new URLSearchParams(h.replace(/^\?/, ""));
          var hd = String(hq.get("day") || "").toLowerCase();
          if (hd === "sat" || hd === "sun") return hd;
        }
      } catch (_) {}
      return null;
    }
    var _lastDeepKey = null;
    function applyDeepLink(force) {
      var linkDay = readDayParam();
      if (linkDay) setDay(linkDay, true);
      var key = readBoothParam();
      if (!force && key === _lastDeepKey) return;
      _lastDeepKey = key;
      var v = findVendor(key);
      if (v) {
        select(v.id);
        // Defer scroll until after layout/paint so SVG has real dimensions.
        var node = boothNodes[v.id];
        if (typeof requestAnimationFrame === "function") {
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              scrollBoothIntoView(node);
            });
          });
        } else {
          setTimeout(function () {
            scrollBoothIntoView(node);
          }, 60);
        }
      } else if (key == null && state.selected) {
        // Back-nav to a URL without ?booth → clear selection
        select(null);
      }
    }
    // Run now, again after layout, and after full load — covers script-in-head,
    // late-mounting Shopify sections, and image-driven layout shifts.
    applyDeepLink(true);
    if (typeof requestAnimationFrame === "function") {
      requestAnimationFrame(function () {
        applyDeepLink(true);
      });
    }
    if (document.readyState !== "complete") {
      window.addEventListener(
        "load",
        function () {
          applyDeepLink(true);
        },
        { once: true },
      );
    }
    window.addEventListener("popstate", function () {
      applyDeepLink(true);
    });
    window.addEventListener("hashchange", function () {
      applyDeepLink(true);
    });
    // iOS Safari restores the page from bfcache without firing popstate.
    window.addEventListener("pageshow", function (e) {
      if (e.persisted) applyDeepLink(true);
    });
    // Watch container data attrs in case a host script sets them after mount.
    if (typeof MutationObserver === "function") {
      try {
        new MutationObserver(function () {
          applyDeepLink(false);
        }).observe(container, { attributes: true, attributeFilter: ["data-deep-link", "data-booth"] });
      } catch (_) {}
    }
  }

  function renderEntrance(panel) {
    panel.innerHTML = "";
    if (panel.__closeBtn) panel.appendChild(panel.__closeBtn);
    panel.appendChild(html("div", { class: "lov-fp-meta" }, "Main Entrance · Hall B"));
    panel.appendChild(html("h3", null, "Welcome to the show"));
    panel.appendChild(
      html(
        "p",
        null,
        "The main entrance is on the south side of Hall B. From here you can walk the central aisle to reach any booth. Tap a table on the map for turn-by-turn directions from this spot.",
      ),
    );
    var box = html("div", {
      style: "margin-top:12px;padding:12px;border-radius:8px;background:#f1f5f9;font-size:13px;line-height:1.5",
    });
    box.appendChild(html("strong", null, "Getting around"));
    var ol = html("ol", { style: "margin:6px 0 0;padding-left:20px;color:#475569" });
    ol.appendChild(html("li", null, "Enter through the main doors at the south side of Hall B."));
    ol.appendChild(html("li", null, "Walk straight up the central aisle."));
    ol.appendChild(html("li", null, "Tap any booth on the map to see its location and route."));
    box.appendChild(ol);
    panel.appendChild(box);
  }

  function renderEmpty(panel) {
    panel.innerHTML = "";
    if (panel.__closeBtn) panel.appendChild(panel.__closeBtn);
    panel.appendChild(
      html(
        "p",
        { class: "lov-fp-empty" },
        "Select a booth on the map to see vendor details and walking directions from the entrance.",
      ),
    );
  }
  function renderVendor(panel, v) {
    panel.innerHTML = "";
    if (panel.__closeBtn) panel.appendChild(panel.__closeBtn);
    panel.appendChild(
      html("div", { class: "lov-fp-meta" }, "Booth " + v.booth + " · " + v.category + " · " + vendorDaysLabel(v)),
    );
    // Clear day-availability badge (Saturday / Sunday / both).
    try {
      var vdAvail = vendorDays(v);
      var availCls = vdAvail.sat && vdAvail.sun ? "both" : vdAvail.sat ? "sat" : "sun";
      var availBadge = html("span", { class: "lov-fp-avail lov-fp-avail--" + availCls });
      availBadge.appendChild(html("span", { class: "lov-fp-avail-dot" }));
      availBadge.appendChild(document.createTextNode(vendorDaysLabel(v)));
      panel.appendChild(availBadge);
    } catch (_) {}
    var logoSrc =
      v.logo ||
      v.logoUrl ||
      v.logo_url ||
      "https://cdn.shopify.com/s/files/1/0016/8892/8354/files/roytato-potato.png?v=1781241271";
    var logoWrap = html("div", { class: "lov-fp-logo" });
    panel.appendChild(html("h3", null, v.name));
    logoWrap.appendChild(html("img", { src: logoSrc, alt: v.name + " logo", loading: "lazy" }));
    panel.appendChild(logoWrap);
    panel.appendChild(html("p", null, v.description));
    if (v.website) {
      var p = html("p");
      var a = html(
        "a",
        { href: /^https?:/.test(v.website) ? v.website : "https://" + v.website, target: "_blank", rel: "noopener" },
        v.website,
      );
      p.appendChild(a);
      panel.appendChild(p);
    }
    // Custom link block — per-vendor "linkUrl"/"link_url"/"link" plus optional
    // "linkLabel"/"linkText"/"link_label". Also supports a "links" array of
    // { url, label } objects for multiple link blocks.
    try {
      var customLinks = [];
      if (Array.isArray(v.links)) {
        v.links.forEach(function (l) {
          if (l && l.url) customLinks.push({ url: String(l.url), label: l.label || l.text || "" });
        });
      }
      var singleUrl = v.linkUrl || v.link_url || v.link;
      if (singleUrl) {
        customLinks.push({ url: String(singleUrl), label: v.linkLabel || v.link_label || v.linkText || "" });
      }
      customLinks.forEach(function (cl) {
        var href = /^https?:/i.test(cl.url) ? cl.url : "https://" + cl.url;
        var linkWrap = html("div", { class: "lov-fp-custom-link" });
        var linkBody = html("div", { class: "lov-fp-custom-link-body" });
        linkBody.appendChild(html("strong", null, cl.label || "Vendor link"));
        linkBody.appendChild(html("a", { class: "lov-fp-share-link", href: href, target: "_blank", rel: "noopener" }, href));
        linkWrap.appendChild(linkBody);
        linkWrap.appendChild(
          html("a", { class: "lov-fp-share-btn", href: href, target: "_blank", rel: "noopener", style: "text-decoration:none" }, "Visit"),
        );
        panel.appendChild(linkWrap);
      });
    } catch (_) {}
    // Share / QR
    try {
      var boothKey = encodeURIComponent(v.id);
      var dayKey = currentShareDay === "sun" ? "sun" : "sat";
      var shareUrl =
        window.location.origin +
        window.location.pathname +
        "?booth=" +
        boothKey +
        "&day=" +
        dayKey +
        "#booth=" +
        boothKey;
      var wrap = html("div", { class: "lov-fp-share" });
      var qrSrc =
        "https://api.qrserver.com/v1/create-qr-code/?size=192x192&margin=1&data=" + encodeURIComponent(shareUrl);
      wrap.appendChild(html("img", { src: qrSrc, alt: "QR code for " + v.name, loading: "lazy" }));
      var body = html("div", { class: "lov-fp-share-body" });
      body.appendChild(html("strong", null, "Share this booth"));
      body.appendChild(html("a", { class: "lov-fp-share-link", href: shareUrl }, shareUrl));
      var btn = html(
        "button",
        { class: "lov-fp-share-btn", type: "button" },
        "Copy link (" + (dayKey === "sun" ? "Sunday" : "Saturday") + ")",
      );
      var btnLabel = btn.textContent;
      btn.addEventListener("click", function () {
        function done() {
          btn.textContent = "Copied!";
          setTimeout(function () {
            btn.textContent = btnLabel;
          }, 1800);
        }
        function fallback() {
          try {
            var ta = document.createElement("textarea");
            ta.value = shareUrl;
            ta.setAttribute("readonly", "");
            ta.style.cssText = "position:fixed;top:0;left:0;opacity:0";
            document.body.appendChild(ta);
            ta.select();
            document.execCommand("copy");
            document.body.removeChild(ta);
            done();
          } catch (_) {
            window.prompt("Copy this link", shareUrl);
          }
        }
        try {
          var p = navigator.clipboard && navigator.clipboard.writeText(shareUrl);
          if (p && typeof p.then === "function") p.then(done, fallback);
          else done();
        } catch (_) {
          fallback();
        }
      });
      body.appendChild(btn);
      wrap.appendChild(body);
      panel.appendChild(wrap);
      /* Buy this table pill
      var buyWrap = html("div", { class: "lov-fp-buy" });
      var buyBody = html("div", { class: "lov-fp-buy-body" });
      buyBody.appendChild(html("strong", null, "Reserve this table"));
      buyBody.appendChild(document.createTextNode("Book booth " + (v.booth || v.id) + " for your brand."));
      buyWrap.appendChild(buyBody);
      var buyHref = v.buyUrl || v.buy_url || "/products/booth-reservation?booth=" + boothKey;
      var buyBtn = html(
        "a",
        { class: "lov-fp-buy-btn", href: buyHref, target: "_blank", rel: "noopener" },
        "Buy this table",
      );
      buyWrap.appendChild(buyBtn);
      panel.appendChild(buyWrap); */
    } catch (_) {}
  }

  function readConfig(node) {
    var raw = node.getAttribute("data-floor-plan");
    if (!raw) return {};
    try {
      return JSON.parse(raw);
    } catch (e) {
      return {};
    }
  }
  function isEditable(node) {
    if (node.hasAttribute("data-editable")) return true;
    try {
      var qs = (window.location.search || "").toLowerCase();
      if (qs.indexOf("fp-edit=1") !== -1) return true;
    } catch (_) {}
    return false;
  }

  var KRAKEN_URL = "https://krakenpintrade.com/cdn/shop/files/kraken-logo-2026-black.png";

  function printFloorPlan(svg, opts, selected, allVendors, day) {
    function esc(s) {
      return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
      });
    }
    if (!svg) return;
    var clone = svg.cloneNode(true);
    clone.removeAttribute("style");
    // Remove booths not open on the selected day so the printout matches it.
    Array.prototype.forEach.call(
      clone.querySelectorAll(".is-day-hidden,.is-day-shadowed"),
      function (n) { n.parentNode && n.parentNode.removeChild(n); }
    );
    Array.prototype.forEach.call(clone.querySelectorAll(".is-dimmed,.is-cat-hidden"), function (n) {
      n.classList.remove("is-dimmed", "is-cat-hidden");
    });
    var dayLabel = day === "sun" ? "Sunday" : day === "sat" ? "Saturday" : "";
    var dirVendors = (allVendors || []).filter(function (v) {
      return !day || vendorDays(v)[day];
    }).slice().sort(function (a, b) {
      return String(a.booth || a.id).localeCompare(String(b.booth || b.id), undefined, { numeric: true });
    });
    var dirHtml = "";
    if (dirVendors.length) {
      dirHtml = "<section class='dir'><h2>Vendor directory" + (dayLabel ? " &middot; " + dayLabel : "") + "</h2><table><thead><tr><th>Booth</th><th>Vendor</th><th>Category</th><th>Details</th></tr></thead><tbody>";
      dirVendors.forEach(function (v) {
        var site = v.website ? String(v.website).replace(/^https?:\/\//, "") : "";
        var det = [v.description, site].filter(Boolean).map(esc).join("<br>");
        dirHtml += "<tr><td class='b'>" + esc(v.booth || v.id) + "</td><td class='n'>" + esc(v.name || "") + "</td><td>" + esc(v.category || "") + "</td><td>" + det + "</td></tr>";
      });
      dirHtml += "</tbody></table></section>";
    }
    clone.removeAttribute("width");
    clone.removeAttribute("height");
    // preserveAspectRatio so the SVG scales to fit its container box.
    clone.setAttribute("preserveAspectRatio", "xMidYMid meet");
    var title = (opts && opts.title) || document.title || "Floor Plan";
    var w = window.open("", "_blank", "width=1024,height=768");
    if (!w) return;
    // Derive aspect ratio from viewBox so the SVG can be sized to fit one page
    // on any paper size / orientation (including mobile portrait printing).
    var vb = (clone.getAttribute("viewBox") || "0 0 1000 700").split(/\s+/);
    var vbW = parseFloat(vb[2]) || 1000;
    var vbH = parseFloat(vb[3]) || 700;
    var landscape = vbW >= vbH;
    var parts = [
      "<!doctype html>",
      "<html><head><meta charset='utf-8'>",
      "<meta name='viewport' content='width=device-width,initial-scale=1'>",
      "<title>" + title + "</title>",
      "<style>",
      // Match page orientation to the map so it always fits one page.
      "@page { size: " + (landscape ? "landscape" : "portrait") + "; margin: 2mm; }",
      "html,body{margin:0;padding:0;background:#fff;color:#000;font-family:system-ui,sans-serif;-webkit-print-color-adjust:exact;print-color-adjust:exact;}",
      "*{page-break-inside:avoid;break-inside:avoid;}",
      ".wrap{box-sizing:border-box;padding:1mm;display:flex;flex-direction:column;gap:4px;}",
      ".hdr{display:flex;align-items:center;gap:1px;flex:0 0 auto;}",
      ".hdr img{height:18px;width:auto;display:block;}",
      ".hdr h1{font-size:12px;margin:0;font-weight:600;}",
      ".hdr .sel{font-size:11px;margin-left:auto;color:#1e3a8a;font-weight:600;display:flex;align-items:center;gap:6px;}",
      ".hdr .sel .dot{display:inline-block;width:10px;height:0;border-top:2px dashed #2563eb;}",
      ".svg-box{flex:0 0 auto;width:100%;display:flex;align-items:center;justify-content:center;}",
      // Size SVG by aspect ratio so it never overflows the printable area.
      ".svg-box svg{display:block;width:100%;height:auto;max-width:100%;aspect-ratio:" + vbW + " / " + vbH + ";}",
      // Ensure route + entrance render in print even without the widget stylesheet.
      ".lov-fp-route{stroke:#1d4ed8;stroke-width:8;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:2 14;fill:none}",
      ".lov-fp-route-glow{display:none}",
      ".lov-fp-walkers{display:none}",
      ".lov-fp-booth-bg{stroke-width:2.5}",

      ".lov-fp-entrance{fill:#10b981}",
      ".lov-fp-entrance-label{font-size:18px;fill:#065f46;font-weight:600}",
      ".hdr .day{font-size:11px;font-weight:700;background:#0f172a;color:#fff;border-radius:999px;padding:2px 10px;margin-left:8px;}",
      ".dir{padding:6mm 4mm;font-size:11px;}",
      ".dir h2{font-size:14px;margin:0 0 6px;}",
      ".dir table{width:100%;border-collapse:collapse;}",
      ".dir th,.dir td{border-bottom:1px solid #cbd5e1;padding:4px 6px;text-align:left;vertical-align:top;}",
      ".dir th{background:#f1f5f9;font-size:10px;text-transform:uppercase;letter-spacing:.04em;}",
      ".dir td.b{font-weight:700;white-space:nowrap;}",
      ".dir td.n{font-weight:600;}",
      "@media screen {",
      "  .wrap{min-height:100vh;}",
      "}",
      "@media print {",
      "  .wrap{height:100vh;overflow:hidden;page-break-after:always;break-after:page;}",
      "  .dir tr{break-inside:avoid;} .dir{break-before:page;} .dir *{page-break-inside:auto;}",
      // Constrain SVG to fit within one page in both dimensions.
      ".lov-fp-spotlights,.lov-fp-thought{display:none!important;}",
      "  .svg-box{flex:1 1 auto;min-height:0;height:100%;}",
      "  .svg-box svg{width:auto;height:auto;max-width:100%;max-height:100%;}",
      "}",
      "</style>",
      "</head><body><div class='wrap'>",
      "<div class='hdr'><img src='" +
        KRAKEN_URL +
        "' alt='Logo'/><h1>" +
        title +
        "</h1>" +
        (dayLabel ? "<span class='day'>" + dayLabel + "</span>" : "") +
        (selected
          ? "<span class='sel'><span class='dot'></span>Route to " +
            esc(selected.name || "Booth " + (selected.booth || selected.id)) +
            (selected.booth ? " (Booth " + esc(String(selected.booth)) + ")" : "") +
            "</span>"
          : "") +
        "</div>",
      "<div class='svg-box'>" + clone.outerHTML + "</div>",
      "</div>" + dirHtml + "</body></html>",
    ];

    w.document.open();
    w.document.write(parts.join(""));
    w.document.close();
    w.focus();
    var img = w.document.querySelector(".hdr img");
    function go() {
      setTimeout(function () {
        w.print();
      }, 200);
    }
    if (img && !img.complete) {
      img.addEventListener("load", go);
      img.addEventListener("error", go);
    } else {
      go();
    }
  }

  function storageKeyFor(node) {
    return node.getAttribute("data-storage-key") || "lov-fp:vendors:" + (node.id || "default");
  }
  function entranceStorageKeyFor(node) {
    return storageKeyFor(node) + ":entrance";
  }
  function gridStorageKeyFor(node) {
    return storageKeyFor(node) + ":grid";
  }
  function bgStorageKeyFor(node) {
    return storageKeyFor(node) + ":bg";
  }

  // ---- Background presets ---------------------------------------------------
  // Each preset returns SVG markup for a <pattern> body (id-less inner nodes)
  // plus a base fill color. Pattern id is assigned when injected.
  var BG_PRESETS = {
    none: null,
    "carpet-red": {
      fill: "#7a1220",
      pattern: 40,
      body:
        '<rect width="40" height="40" fill="#7a1220"/>' +
        '<path d="M0 40L40 0" stroke="#5a0d17" stroke-width="6"/>' +
        '<path d="M-10 10L10 -10M30 50L50 30" stroke="#8a1826" stroke-width="4"/>',
    },
    "carpet-blue": {
      fill: "#1e3a8a",
      pattern: 40,
      body:
        '<rect width="40" height="40" fill="#1e3a8a"/>' +
        '<path d="M0 40L40 0" stroke="#152a63" stroke-width="6"/>' +
        '<path d="M-10 10L10 -10M30 50L50 30" stroke="#2748a3" stroke-width="4"/>',
    },
    "carpet-gray": {
      fill: "#3f4650",
      pattern: 40,
      body:
        '<rect width="40" height="40" fill="#3f4650"/>' +
        '<path d="M0 40L40 0" stroke="#2e343c" stroke-width="6"/>' +
        '<path d="M-10 10L10 -10M30 50L50 30" stroke="#4e5561" stroke-width="4"/>',
    },
    wood: {
      fill: "#a97449",
      pattern: 120,
      body:
        '<rect width="120" height="120" fill="#a97449"/>' +
        '<rect y="0" width="120" height="30" fill="#b8814f"/>' +
        '<rect y="60" width="120" height="30" fill="#9a683f"/>' +
        '<path d="M0 30h120M0 60h120M0 90h120M0 120h120" stroke="#6b4a2b" stroke-width="1.5"/>' +
        '<path d="M40 0v30M80 30v30M20 60v30M90 90v30" stroke="#6b4a2b" stroke-width="1.5"/>',
    },
    checker: {
      fill: "#e5e7eb",
      pattern: 80,
      body:
        '<rect width="80" height="80" fill="#e5e7eb"/>' +
        '<rect width="40" height="40" fill="#cbd5e1"/>' +
        '<rect x="40" y="40" width="40" height="40" fill="#cbd5e1"/>',
    },
    concrete: {
      fill: "#d6d3d1",
      pattern: 60,
      body:
        '<rect width="60" height="60" fill="#d6d3d1"/>' +
        '<circle cx="10" cy="15" r="1" fill="#a8a29e" opacity=".6"/>' +
        '<circle cx="42" cy="8" r="1.2" fill="#a8a29e" opacity=".5"/>' +
        '<circle cx="25" cy="40" r="1" fill="#a8a29e" opacity=".6"/>' +
        '<circle cx="50" cy="48" r="1.4" fill="#a8a29e" opacity=".5"/>' +
        '<circle cx="5" cy="52" r="1" fill="#a8a29e" opacity=".4"/>',
    },
    grid: {
      fill: "#f8fafc",
      pattern: 40,
      body:
        '<rect width="40" height="40" fill="#f8fafc"/>' +
        '<path d="M40 0H0V40" stroke="#e2e8f0" stroke-width="1" fill="none"/>',
    },
  };
  var BG_LABELS = {
    none: "None",
    "carpet-red": "Red carpet",
    "carpet-blue": "Blue carpet",
    "carpet-gray": "Gray carpet",
    wood: "Wood floor",
    checker: "Checker tile",
    concrete: "Concrete",
    grid: "Grid paper",
  };

  function resolveBackground(node) {
    var bg = { type: "none", value: "", color: "" };
    try {
      var saved = localStorage.getItem(bgStorageKeyFor(node));
      if (saved) {
        var parsed = JSON.parse(saved);
        if (parsed && typeof parsed === "object") return Object.assign(bg, parsed);
      }
    } catch (_) {}
    var attr = node.getAttribute && node.getAttribute("data-bg");
    var color = node.getAttribute && node.getAttribute("data-bg-color");
    if (attr) {
      if (/^(https?:|data:|\/)/i.test(attr)) {
        bg.type = "image";
        bg.value = attr;
      } else if (BG_PRESETS[attr] !== undefined) {
        bg.type = "preset";
        bg.value = attr;
      }
    }
    if (color) bg.color = color;
    return bg;
  }

  function renderBackground(svg, bg) {
    if (!bg || bg.type === "none") {
      if (bg && bg.color) {
        svg.insertBefore(el("rect", { x: 0, y: 0, width: W, height: H, fill: bg.color }), svg.firstChild);
      }
      return;
    }
    var defs = el("defs");
    var patId = "lov-fp-bg-" + Math.random().toString(36).slice(2, 8);
    var fill = "url(#" + patId + ")";
    if (bg.type === "preset") {
      var p = BG_PRESETS[bg.value];
      if (!p) return;
      var pat = el("pattern", {
        id: patId,
        patternUnits: "userSpaceOnUse",
        width: p.pattern,
        height: p.pattern,
      });
      // Inner body is raw SVG markup — parse via a scratch <svg>.
      var tmp = document.createElementNS(SVG_NS, "svg");
      tmp.innerHTML = p.body;
      while (tmp.firstChild) pat.appendChild(tmp.firstChild);
      defs.appendChild(pat);
    } else if (bg.type === "image") {
      var img = el("pattern", {
        id: patId,
        patternUnits: "userSpaceOnUse",
        width: 200,
        height: 200,
      });
      img.appendChild(
        el("image", {
          href: bg.value,
          "xlink:href": bg.value,
          x: 0,
          y: 0,
          width: 200,
          height: 200,
          preserveAspectRatio: "xMidYMid slice",
        }),
      );
      defs.appendChild(img);
    } else {
      return;
    }
    svg.insertBefore(defs, svg.firstChild);
    svg.insertBefore(
      el("rect", {
        x: 0,
        y: 0,
        width: W,
        height: H,
        fill: fill,
        "pointer-events": "none",
      }),
      defs.nextSibling,
    );
  }

  // Resolve grid dimensions (columns x rows) from (priority order):
  //   1) saved grid size in localStorage
  //   2) data-cols / data-rows attributes on the container
  //   3) ?cols= / ?rows= URL parameters
  //   4) built-in defaults (12 x 9)
  function resolveGridSize(node) {
    var def = { cols: 12, rows: 9 };
    function clampInt(n, fallback) {
      n = parseInt(n, 10);
      if (!isFinite(n)) return fallback;
      return Math.max(1, Math.min(60, n));
    }
    try {
      var raw = localStorage.getItem(gridStorageKeyFor(node));
      if (raw) {
        var s = JSON.parse(raw);
        if (s && isFinite(s.cols) && isFinite(s.rows)) {
          return { cols: clampInt(s.cols, def.cols), rows: clampInt(s.rows, def.rows) };
        }
      }
    } catch (_) {}
    var cAttr = node.getAttribute && node.getAttribute("data-cols");
    var rAttr = node.getAttribute && node.getAttribute("data-rows");
    var fromCols = cAttr != null ? parseInt(cAttr, 10) : NaN;
    var fromRows = rAttr != null ? parseInt(rAttr, 10) : NaN;
    var cUrl, rUrl;
    try {
      var mc = (window.location.search || "").match(/[?&]cols=([^&]+)/);
      var mr = (window.location.search || "").match(/[?&]rows=([^&]+)/);
      if (mc) cUrl = parseInt(decodeURIComponent(mc[1]), 10);
      if (mr) rUrl = parseInt(decodeURIComponent(mr[1]), 10);
    } catch (_) {}
    return {
      cols: clampInt(isFinite(fromCols) ? fromCols : cUrl, def.cols),
      rows: clampInt(isFinite(fromRows) ? fromRows : rUrl, def.rows),
    };
  }

  function loadSaved(node) {
    try {
      var raw = localStorage.getItem(storageKeyFor(node));
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (Array.isArray(parsed) && parsed.length) return parsed;
    } catch (_) {}
    return null;
  }

  // Resolve entrance position from (in priority order):
  //   1) saved layout in localStorage
  //   2) data-entrance="col,row" attribute on the container
  //   3) ?entrance=col,row URL parameter
  //   4) bottom-center default
  // col/row may be fractional (e.g. row = ROWS + 0.5 to sit just outside the
  // bottom edge of the grid like the original entrance).
  function resolveEntrance(node) {
    var def = { col: Math.ceil(COLS / 2), row: ROWS + 0.5 };
    function parsePair(s) {
      if (s == null || s === "") return null;
      var parts = String(s)
        .split(",")
        .map(function (x) {
          return parseFloat(x);
        });
      if (parts.length >= 2 && isFinite(parts[0]) && isFinite(parts[1])) {
        return { col: parts[0], row: parts[1] };
      }
      return null;
    }
    try {
      var raw = localStorage.getItem(entranceStorageKeyFor(node));
      if (raw) {
        var s = JSON.parse(raw);
        if (s && isFinite(s.col) && isFinite(s.row)) return { col: s.col, row: s.row };
      }
    } catch (_) {}
    var attr = node.getAttribute && node.getAttribute("data-entrance");
    var fromAttr = parsePair(attr);
    if (fromAttr) return fromAttr;
    try {
      var m = (window.location.search || "").match(/[?&]entrance=([^&]+)/);
      if (m) {
        var fromUrl = parsePair(decodeURIComponent(m[1]));
        if (fromUrl) return fromUrl;
      }
    } catch (_) {}
    return def;
  }

  // Render the page header + edit-mode toggle around the widget container.
  // Replaces the old React wrapper. Opt-in via `data-with-chrome` on the
  // container. Hidden when the URL has `?embed=1`.
  function attachChrome(node) {
    if (node.__lovFpChromeAttached) return;
    if (!node.hasAttribute("data-with-chrome")) return;
    node.__lovFpChromeAttached = true;
    var embed = false;
    try {
      var qs = (window.location.search || "").toLowerCase();
      if (qs.indexOf("embed=1") !== -1 || qs.indexOf("embed=true") !== -1) embed = true;
    } catch (_) {}
    try {
      document.body.classList.add("lov-fp-page");
    } catch (_) {}
    // Wrap the container in a <main> so layout matches the old React shell.
    if (!node.closest(".lov-fp-main") && node.parentNode) {
      var main = document.createElement("main");
      main.className = "lov-fp-main";
      node.parentNode.insertBefore(main, node);
      main.appendChild(node);
    }
    if (embed) return;
    var titleText = node.getAttribute("data-title") || "Tradeshow Floor Map";
    var eyebrowText = node.getAttribute("data-eyebrow") || "Hall B \u00b7 June 12\u201314";
    var subtitleText =
      node.getAttribute("data-subtitle") ||
      "Tap any table to see vendor details and walking directions from the entrance.";
    var header = document.createElement("header");
    header.className = "lov-fp-header";
    var inner = document.createElement("div");
    inner.className = "lov-fp-header-inner";
    var titleWrap = document.createElement("div");
    if (eyebrowText) {
      var eyebrow = document.createElement("p");
      eyebrow.className = "lov-fp-eyebrow";
      eyebrow.textContent = eyebrowText;
      titleWrap.appendChild(eyebrow);
    }
    var h1 = document.createElement("h1");
    h1.className = "lov-fp-title";
    h1.textContent = titleText;
    titleWrap.appendChild(h1);
    if (subtitleText) {
      var sub = document.createElement("p");
      sub.className = "lov-fp-subtitle";
      sub.textContent = subtitleText;
      titleWrap.appendChild(sub);
    }
    inner.appendChild(titleWrap);
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "lov-fp-edit-toggle";
    function syncBtn() {
      var on = node.hasAttribute("data-editable");
      btn.textContent = on ? "Exit edit mode" : "Edit floor plan";
      btn.setAttribute("aria-pressed", on ? "true" : "false");
      btn.classList.toggle("is-on", on);
    }
    syncBtn();
    btn.addEventListener("click", function () {
      var on = node.hasAttribute("data-editable");
      if (on) node.removeAttribute("data-editable");
      else node.setAttribute("data-editable", "");
      syncBtn();
      node.__lovFpMounted = false;
      node.innerHTML = "";
      mount(node);
    });
    inner.appendChild(btn);
    header.appendChild(inner);
    var anchor = node.closest(".lov-fp-main") || node;
    if (anchor.parentNode) anchor.parentNode.insertBefore(header, anchor);
  }

  function mount(node) {
    if (node.__lovFpMounted) return;
    node.__lovFpMounted = true;
    attachChrome(node);
    var cfg = readConfig(node);
    var editable = isEditable(node);
    var storageKey = storageKeyFor(node);
    var entranceStorageKey = entranceStorageKeyFor(node);
    var gridStorageKey = gridStorageKeyFor(node);

    // Apply configured / saved grid size BEFORE entrance resolution so the
    // default-entrance fallback (bottom-center) uses the new dimensions.
    var grid = resolveGridSize(node);
    COLS = grid.cols;
    ROWS = grid.rows;
    W = COLS * CELL + PAD * 2;
    H = ROWS * CELL + PAD * 2;

    // Apply configured / saved entrance position before any rendering happens
    // (computePath, walker spawning, etc. all read from the module-level
    // ENTRANCE object).
    var ent = resolveEntrance(node);
    ENTRANCE.col = ent.col;
    ENTRANCE.row = ent.row;

    // Parse decorative doors from data-doors='[{"col":3,"row":0,"side":"top","label":"North"}, ...]'
    var doors = [];
    try {
      var doorsRaw = node.getAttribute("data-doors");
      if (doorsRaw) {
        var dp = JSON.parse(doorsRaw);
        if (Array.isArray(dp)) doors = dp;
      }
    } catch (_) {}

    // Parse walls from data-walls='[{"col":3,"row":4,"length":5,"orient":"h","openings":[2],"label":"North wall"}, ...]'
    var walls = [];
    try {
      var wallsRaw = node.getAttribute("data-walls");
      if (wallsRaw) {
        var wp = JSON.parse(wallsRaw);
        if (Array.isArray(wp)) walls = wp;
      }
    } catch (_) {}

    // Parse spotlights from data-spotlights='[{"boothId":"V1","title":"Exclusive Drop","image":"https://...","text":"Limited to 100 units","eyebrow":"EVENT EXCLUSIVE"}, ...]'
    // boothId can also match by vendor.booth (booth number) or vendor.id.
    var spotlights = [];
    try {
      var spotRaw = node.getAttribute("data-spotlights");
      if (spotRaw) {
        var sp = JSON.parse(spotRaw);
        if (Array.isArray(sp)) spotlights = sp;
      }
    } catch (_) {}

    // Parse mascot customization from data-mascots='{"mascotUrl":"https://.../soccer.png","mascotSize":80,"dotUrl":"https://.../ball.png","dotSize":28,"dotColor":"#000","entranceMascotUrl":"...","entranceMascotSize":100}'
    var mascots = null;
    try {
      var mRaw = node.getAttribute("data-mascots");
      if (mRaw) {
        var mp = JSON.parse(mRaw);
        if (mp && typeof mp === "object") mascots = mp;
      }
    } catch (_) {}

    var bg = resolveBackground(node);
    var bgStorageKey = bgStorageKeyFor(node);

    function go(list) {
      var copy = list.map(function (v) {
        return Object.assign({}, v);
      });
      var initial = list.map(function (v) {
        return Object.assign({}, v);
      });
      render(node, copy, {
        editable: editable,
        initial: initial,
        storageKey: storageKey,
        entranceStorageKey: entranceStorageKey,
        gridStorageKey: gridStorageKey,
        bgStorageKey: bgStorageKey,
        background: bg,
        doors: doors,
        walls: walls,
        spotlights: spotlights.length ? spotlights : DEFAULT_SPOTLIGHTS,
        mascots: mascots,
      });
    }

    // Lenient JSON parse: tolerates smart quotes, trailing commas and stray
    // newlines that Shopify/Liquid templates commonly inject into attributes.
    function lenientParse(raw) {
      try {
        return JSON.parse(raw);
      } catch (e) {
        var cleaned = String(raw)
          .replace(/[\u2018\u2019]/g, "'")
          .replace(/[\u201C\u201D]/g, '"')
          .replace(/,(\s*[}\]])/g, "$1")
          .replace(/^\s*[\r\n]+|[\r\n]+\s*$/g, "");
        return JSON.parse(cleaned);
      }
    }
    function showDataError(msg) {
      try {
        var warn = document.createElement("div");
        warn.className = "lov-fp-dataerror";
        warn.setAttribute("role", "alert");
        warn.style.cssText =
          "margin:8px 0;padding:10px 14px;border-radius:10px;font:600 13px/1.4 system-ui,sans-serif;background:#fef2f2;color:#991b1b;border:1px solid #fecaca";
        warn.textContent = msg;
        node.insertBefore(warn, node.firstChild);
      } catch (_) {}
    }
    function idsOf(list) {
      return list
        .map(function (v) {
          return String((v && (v.id || v.booth)) || "");
        })
        .sort()
        .join("|");
    }

    var inlineList = null;
    var inlineRaw = node.getAttribute("data-vendors");
    if (inlineRaw && inlineRaw.trim()) {
      try {
        var parsed = lenientParse(inlineRaw);
        if (Array.isArray(parsed) && parsed.length) inlineList = parsed;
        else showDataError("Floor plan: data-vendors is empty — showing demo booths.");
      } catch (e) {
        console.warn("[floor-plan] invalid data-vendors JSON:", e);
        showDataError(
          "Floor plan: the booth list could not be read (" + (e && e.message ? e.message : "invalid JSON") + ")."
        );
      }
    }

    if (!inlineList) {
      var tag = node.querySelector('script[type="application/json"]');
      if (tag) {
        try {
          var parsed2 = lenientParse(tag.textContent || "[]");
          if (Array.isArray(parsed2) && parsed2.length) inlineList = parsed2;
        } catch (e2) {
          console.warn("[floor-plan] invalid inline <script> JSON:", e2);
          showDataError("Floor plan: the booth list script block could not be read.");
        }
      }
    }

    // Saved layout from localStorage keeps user edits, but only when it still
    // matches the booths supplied by the page. Otherwise the page data wins.
    var saved = loadSaved(node);
    if (saved && saved.length) {
      if (!inlineList || idsOf(saved) === idsOf(inlineList)) {
        go(saved);
        return;
      }
    }

    if (inlineList) {
      go(inlineList);
      return;
    }


    if (cfg.vendorsUrl) {
      fetch(cfg.vendorsUrl)
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          go(Array.isArray(data) && data.length ? data : DEFAULT_VENDORS);
        })
        .catch(function () {
          go(DEFAULT_VENDORS);
        });
      return;
    }

    go(DEFAULT_VENDORS);
  }

  function init() {
    ensureStyles();
    var nodes = document.querySelectorAll("[data-floor-plan]");
    for (var i = 0; i < nodes.length; i++) mount(nodes[i]);
    // Watch for containers added later by client-side frameworks (e.g. after
    // React hydration finishes). Without this, a `data-floor-plan` div that
    // hydrates after DOMContentLoaded never gets mounted.
    if (!window.__lovFpObserver && typeof MutationObserver === "function") {
      window.__lovFpObserver = new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var added = records[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (!n || n.nodeType !== 1) continue;
            if (n.hasAttribute && n.hasAttribute("data-floor-plan")) mount(n);
            if (n.querySelectorAll) {
              var nested = n.querySelectorAll("[data-floor-plan]");
              for (var k = 0; k < nested.length; k++) mount(nested[k]);
            }
          }
        }
      });
      window.__lovFpObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  // Expose a small global so host pages (e.g. our React route) can re-init
  // after mounting a container dynamically.
  function addWalker(opts, container) {
    container = container || document.querySelector("[data-floor-plan]");
    if (!container) return null;
    var tries = 0;
    function attempt() {
      if (container.__lovFpAddWalker) return container.__lovFpAddWalker(opts);
      if (tries++ < 40) return setTimeout(attempt, 100);
      console.warn("[floor-plan] addWalker: container not ready");
    }
    return attempt();
  }
  window.LovableFloorPlan = { init: init, mount: mount, addWalker: addWalker };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
